/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ===============================================
# Predictive search – locale 付き /search URL の補正（theme.js 非改変）
=============================================== */
(function () {
  var localeSearchPrefixPattern = /^\/[a-z]{2}(?:-[A-Za-z]{2})?\/search(?:\/suggest)?/;

  function toRootSearchUrl(url) {
    if (typeof url !== 'string' || url.indexOf('/search') === -1) {
      return url;
    }

    try {
      var parsed = new URL(url, window.location.origin);
      if (localeSearchPrefixPattern.test(parsed.pathname)) {
        parsed.pathname = parsed.pathname.replace(/^\/[a-z]{2}(?:-[A-Za-z]{2})?/, '');
        return parsed.pathname + parsed.search + parsed.hash;
      }
    } catch (e) {
      if (localeSearchPrefixPattern.test(url)) {
        return url.replace(/^\/[a-z]{2}(?:-[A-Za-z]{2})?/, '');
      }
    }

    return url;
  }

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    if (typeof input === 'string') {
      input = toRootSearchUrl(input);
    } else if (input && typeof input.url === 'string') {
      var fixedUrl = toRootSearchUrl(input.url);
      if (fixedUrl !== input.url) {
        input = new Request(fixedUrl, input);
      }
    }

    return nativeFetch(input, init);
  };
})();

function buildPredictiveSearchSectionUrl(query, useSuggestApi) {
  var path = useSuggestApi !== false ? '/search/suggest' : '/search';
  return (
    path +
    '?section_id=predictive-search&q=' +
    encodeURIComponent(query) +
    '&resources[limit]=3&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor'
  );
}

// 2025/11/28 - アナウンスバー閉じるボタン（by Watanabe）
const Animation = window.Animation;
const Accessibility = window.Accessibility;

/** カート点数上限（layout/theme.liquid window.theme.cartMaxLineItems） */
window.themeGetCartMaxLineItems = function () {
  return (window.theme && window.theme.cartMaxLineItems) || 100;
};

function themeFetchCartItemCountFromApi() {
  return new Promise(function (resolve) {
    if (!window.routes || !window.routes.cartUrl) {
      resolve(0);
      return;
    }
    fetch(window.routes.cartUrl + '.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return { item_count: 0 };
      })
      .then(function (cart) {
        resolve(cart.item_count || 0);
      })
      .catch(function () {
        resolve(0);
      });
  });
}

/**
 * カート内合計点数を取得（ヘッダー「99+」表示時は data-actual-count を優先）
 * @param {{ fresh?: boolean }} [options] fresh:true のとき Cart API のみ参照（上限チェック用）
 * @returns {Promise<number>}
 */
window.themeGetCartItemCount = function (options) {
  options = options || {};
  if (options.fresh) {
    return themeFetchCartItemCountFromApi();
  }

  return new Promise(function (resolve) {
    const cartCountEl = document.querySelector('.custom-header__cart-count, .header__cart-count');
    if (cartCountEl) {
      if (cartCountEl.hasAttribute('data-actual-count')) {
        const actual = parseInt(cartCountEl.getAttribute('data-actual-count'), 10);
        if (!isNaN(actual)) {
          resolve(actual);
          return;
        }
      }
      const text = cartCountEl.textContent ? cartCountEl.textContent.trim() : '';
      if (text && text !== '99+') {
        const n = parseInt(text, 10);
        if (!isNaN(n)) {
          resolve(n);
          return;
        }
      }
    }

    const miniCartEl = document.getElementById('mini-cart');
    if (miniCartEl && miniCartEl.getAttribute('data-item-count')) {
      resolve(parseInt(miniCartEl.getAttribute('data-item-count'), 10) || 0);
      return;
    }

    if (typeof window.theme !== 'undefined' && typeof window.theme.cartCount === 'number') {
      resolve(window.theme.cartCount);
      return;
    }

    themeFetchCartItemCountFromApi().then(resolve);
  });
};

/**
 * カート投入可能か（Cart API・同時リクエストは1本に集約）
 * @param {number} quantityToAdd
 * @returns {Promise<{ allowed: boolean, count: number }>}
 */
window.themeAssertCartHasRoom = function (quantityToAdd) {
  const qty = Math.max(1, parseInt(quantityToAdd, 10) || 1);
  const max = window.themeGetCartMaxLineItems();

  function finish(count) {
    return { allowed: count + qty <= max, count: count };
  }

  if (window.__themeCartRoomCheckInflight) {
    return window.__themeCartRoomCheckInflight.then(finish);
  }

  window.__themeCartRoomCheckInflight = window
    .themeGetCartItemCount({ fresh: true })
    .then(function (count) {
      return finish(count);
    })
    .finally(function () {
      window.__themeCartRoomCheckInflight = null;
    });

  return window.__themeCartRoomCheckInflight;
};

/** カート点数上限の案内（layout/theme.liquid #cart-full-popup） */
window.themeShowCartFullPopup = function () {
  const popup = document.getElementById('cart-full-popup');
  if (!popup) return;

  const now = Date.now();
  if (popup.getAttribute('aria-hidden') === 'false') {
    return;
  }
  if (window.__themeCartFullPopupAt && now - window.__themeCartFullPopupAt < 2000) {
    return;
  }
  window.__themeCartFullPopupAt = now;

  popup.setAttribute('aria-hidden', 'false');
  const closeButton = popup.querySelector('.custom-cart-full-popup__close');
  if (closeButton) closeButton.focus();
};

/** カート件数キャッシュを DOM / window.theme に反映（上限チェックのずれ防止） */
window.themeUpdateCartCountCache = function (itemCount) {
  if (typeof itemCount !== 'number' || isNaN(itemCount)) {
    return;
  }
  if (window.theme) {
    window.theme.cartCount = itemCount;
  }
  const cartCountEl = document.querySelector('.custom-header__cart-count, .header__cart-count');
  if (cartCountEl) {
    cartCountEl.setAttribute('data-actual-count', String(itemCount));
    if (itemCount >= 100) {
      cartCountEl.textContent = '99+';
      cartCountEl.classList.add('custom-header__cart-count--over');
    } else {
      cartCountEl.textContent = String(itemCount);
      cartCountEl.classList.remove('custom-header__cart-count--over');
    }
  }
  const miniCartEl = document.getElementById('mini-cart');
  if (miniCartEl) {
    miniCartEl.setAttribute('data-item-count', String(itemCount));
  }
};

function themeSetAvailabilityAddButtonBusy(addButton, busy) {
  if (!addButton) return;
  if (busy) {
    addButton.dataset.themeAdding = 'true';
    addButton.disabled = true;
    addButton.setAttribute('aria-busy', 'true');
  } else {
    delete addButton.dataset.themeAdding;
    addButton.removeAttribute('aria-busy');
    if (!addButton.classList.contains('button--disabled')) {
      addButton.disabled = false;
    }
  }
}

function themeReleaseAvailabilityAddButtons() {
  document.querySelectorAll('.product-availability-info__add-button[data-theme-adding]').forEach(function (btn) {
    themeSetAvailabilityAddButtonBusy(btn, false);
  });
}

function themeGetAvailabilityQuantityMax(variant, availabilityInfo) {
  const limitAttr = availabilityInfo ? availabilityInfo.getAttribute('data-quantity-limit') : null;
  const parsedLimit = limitAttr ? parseInt(limitAttr, 10) : NaN;
  let max = !isNaN(parsedLimit) && parsedLimit > 0 ? parsedLimit : 100;

  if (variant && variant.quantity_rule && variant.quantity_rule.max != null) {
    max = Math.min(max, variant.quantity_rule.max);
  }

  return max;
}

function themeResolveAvailabilityInfo(availabilityInfo, mainForm) {
  if (availabilityInfo) return availabilityInfo;
  if (mainForm && mainForm.closest) {
    return mainForm.closest('.product-availability-info');
  }
  return document.querySelector('.product-availability-info');
}

function themeGetProductQuantityLimit(availabilityInfo, mainForm) {
  const el = themeResolveAvailabilityInfo(availabilityInfo, mainForm);
  const limitAttr = el ? el.getAttribute('data-quantity-limit') : null;
  const parsedLimit = limitAttr ? parseInt(limitAttr, 10) : NaN;
  return !isNaN(parsedLimit) && parsedLimit > 0 ? parsedLimit : 100;
}

function themeGetBuyButtonQuantityLimit(buyRoot, form) {
  if (buyRoot) {
    const limitAttr = buyRoot.getAttribute('data-quantity-limit');
    const parsedLimit = limitAttr ? parseInt(limitAttr, 10) : NaN;
    if (!isNaN(parsedLimit) && parsedLimit > 0) {
      return parsedLimit;
    }
  }
  const availabilityInfo = themeResolveAvailabilityInfo(
    buyRoot && buyRoot.closest ? buyRoot.closest('.product-availability-info') : null,
    form
  );
  return themeGetProductQuantityLimit(availabilityInfo, form);
}

function themeResolveQuantityLimitForCartAdd(variantId, sourceElement) {
  if (sourceElement) {
    const limitAttr = sourceElement.getAttribute('data-quantity-limit');
    const parsedLimit = limitAttr ? parseInt(limitAttr, 10) : NaN;
    if (!isNaN(parsedLimit) && parsedLimit > 0) {
      return parsedLimit;
    }
  }
  if (variantId != null) {
    const variantInputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    for (let i = 0; i < variantInputs.length; i++) {
      const input = variantInputs[i];
      if (String(input.value) === String(variantId)) {
        const form = input.closest('form');
        const buyRoot = form ? form.querySelector('buy-button') : null;
        return themeGetBuyButtonQuantityLimit(buyRoot, form);
      }
    }
  }
  return themeGetProductQuantityLimit(document.querySelector('.product-availability-info'), null);
}

function themeValidateListingCartAdd(variantId, requestedQty, quantityLimit, giftWrapRequested) {
  return themeFetchCartState().then(function (cart) {
    return themeValidateCartAddQuantity(
      cart,
      variantId,
      requestedQty,
      quantityLimit,
      window.themeGetCartMaxLineItems(),
      giftWrapRequested
    );
  });
}

function themeApplyListingCartAddValidationFailure(validation, quantityLimit, requestedQty) {
  if (validation.reason === 'cart_max_exceed') {
    window.themeShowCartFullPopup();
  } else if (validation.reason === 'product_limit_full') {
    themeAlertProductQuantityLimitExceeded(
      validation.quantityLimit || quantityLimit,
      validation.inCart || 0,
      validation.requested || requestedQty
    );
  }
}

function themeSyncBuyButtonFormQuantity(form, quantity) {
  const quantityInputs = form.querySelectorAll('[name="quantity"]');
  quantityInputs.forEach(function (input) {
    input.value = String(quantity);
    input.setAttribute('value', String(quantity));
  });
  if (form.elements && form.elements.namedItem('quantity')) {
    form.elements.namedItem('quantity').value = String(quantity);
  }
}

function themeGetAvailabilityVariantFromPicker() {
  const variantJsonEl = document.querySelector('variant-picker script[data-variant]');
  if (variantJsonEl) {
    try {
      return JSON.parse(variantJsonEl.textContent || '{}');
    } catch (err) {
      /* ignore */
    }
  }
  return null;
}

function themeResolveProductVariant(variantId) {
  const candidates = [];
  const fromPicker = themeGetAvailabilityVariantFromPicker();
  if (fromPicker) {
    candidates.push(fromPicker);
  }
  if (window.__themeCurrentProductVariant) {
    candidates.push(window.__themeCurrentProductVariant);
  }

  for (let i = 0; i < candidates.length; i++) {
    const candidate = candidates[i];
    if (candidate && String(candidate.id) === String(variantId)) {
      return candidate;
    }
  }

  const availabilityInfo = document.querySelector('.product-availability-info');
  if (
    availabilityInfo &&
    availabilityInfo.dataset.inventoryManagement === 'shopify' &&
    availabilityInfo.dataset.inventoryPolicy === 'deny'
  ) {
    return {
      id: variantId,
      inventory_management: 'shopify',
      inventory_policy: 'deny',
      inventory_quantity: parseInt(availabilityInfo.dataset.inventoryQuantity, 10) || 0
    };
  }

  return fromPicker || window.__themeCurrentProductVariant || null;
}

function themeUpdateAvailabilityInventoryData(variant) {
  const availabilityInfo = document.querySelector('.product-availability-info');
  if (!availabilityInfo || !variant) return;
  availabilityInfo.dataset.inventoryQuantity = String(
    variant.inventory_quantity != null ? variant.inventory_quantity : ''
  );
  availabilityInfo.dataset.inventoryManagement = variant.inventory_management || '';
  availabilityInfo.dataset.inventoryPolicy = variant.inventory_policy || '';
  window.__themeCurrentProductVariant = variant;
}

function themeGetInventoryRemaining(cart, variantId, variant) {
  if (
    !variant ||
    variant.inventory_management !== 'shopify' ||
    variant.inventory_policy !== 'deny'
  ) {
    return null;
  }
  const inventoryQty =
    typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0;
  const inCart = themeGetVariantQtyInCart(cart, variantId);
  return Math.max(0, inventoryQty - inCart);
}

function themeGetInventoryAddableQuantity(cart, variantId, variant, requestedQty) {
  const requested = parseInt(requestedQty, 10) || 0;
  const remaining = themeGetInventoryRemaining(cart, variantId, variant);

  if (remaining === null) {
    return {
      addQty: requested,
      limited: false,
      remaining: null,
      requested: requested
    };
  }

  const addQty = Math.min(requested, remaining);
  return {
    addQty: addQty,
    limited: requested > remaining,
    remaining: remaining,
    requested: requested
  };
}

function themeGetCartAvailabilityLimitedMessage(quantity) {
  const qty = quantity != null && !isNaN(parseInt(quantity, 10)) ? parseInt(quantity, 10) : 1;
  const template =
    (window.languages && window.languages.productCartAvailabilityLimited) ||
    'Only [[quantity]] quantity was added to your cart due to availability.';
  return String(template).replace(/\[\[quantity\]\]/g, String(qty));
}

function themeGetCartQuantityLimitLimitedMessage(quantity, limit, skipped) {
  const qty = quantity != null && !isNaN(parseInt(quantity, 10)) ? parseInt(quantity, 10) : 1;
  const limitVal = limit != null && !isNaN(parseInt(limit, 10)) ? parseInt(limit, 10) : 100;
  const skippedVal = skipped != null && !isNaN(parseInt(skipped, 10)) ? parseInt(skipped, 10) : 0;
  const template =
    (window.languages && window.languages.productCartQuantityLimitLimited) ||
    'This item is limited to [[limit]] units per order. [[quantity]] unit(s) were added to your cart. [[skipped]] unit(s) could not be added due to this limit.';
  return String(template)
    .replace(/\[\[limit\]\]/g, String(limitVal))
    .replace(/\[\[quantity\]\]/g, String(qty))
    .replace(/\[\[skipped\]\]/g, String(skippedVal));
}

function themeGetCartInventoryMaxInCartMessage() {
  return (
    (window.languages && window.languages.productCartInventoryMaxInCart) ||
    'The maximum quantity of this item is already in your cart.'
  );
}

function themeShowProductCartNotice(message) {
  if (!message) return;
  document
    .querySelectorAll('.product-block-list__item--info .product-cart-notice')
    .forEach(function (notice) {
      notice.textContent = message;
      notice.classList.remove('hidden');
    });
}

function themeHideProductCartNotice() {
  document
    .querySelectorAll('.product-block-list__item--info .product-cart-notice')
    .forEach(function (notice) {
      notice.textContent = '';
      notice.classList.add('hidden');
    });
}

function themeIsMaxQuantityInCartDescription(desc) {
  const s = String(desc || '').trim();
  if (!s) return false;
  const patterns = [
    /^The maximum quantity of this item is already in your cart\.?$/i,
    /^All \d+ .+ (is|are) in your cart/i,
    /^You can't add more of this item to your cart/i,
    /^You cannot add more of this item to your cart/i
  ];
  return patterns.some(function (pattern) {
    return pattern.test(s);
  });
}

function themeNormalizeAvailabilityQuantityInput(input) {
  if (!input) return 0;

  const minVal = 0;
  const maxAttr = input.getAttribute('max');
  const max =
    maxAttr !== null && maxAttr !== '' && !isNaN(parseInt(maxAttr, 10))
      ? parseInt(maxAttr, 10)
      : null;

  const raw = String(input.value).trim();
  if (raw === '') {
    input.value = 0;
    input.setAttribute('value', '0');
    return 0;
  }

  let quantity = parseInt(raw, 10);
  if (isNaN(quantity)) {
    input.value = 0;
    input.setAttribute('value', '0');
    return 0;
  }

  if (quantity < minVal) quantity = minVal;
  if (max !== null && quantity > max) quantity = max;

  input.value = quantity;
  input.setAttribute('value', String(quantity));
  return quantity;
}

function themeApplyAvailabilityVariantQuantityLimits(variant, availabilityInfo) {
  if (!availabilityInfo) return;
  const input = availabilityInfo.querySelector('input[name="quantity"]');
  if (!input) return;

  const baseMax = themeGetAvailabilityQuantityMax(variant, availabilityInfo);
  input.setAttribute('data-base-max', String(baseMax));
  input.setAttribute('max', String(baseMax));
  themeNormalizeAvailabilityQuantityInput(input);
}

function themeGetAvailabilityVariantIdFromForm(mainForm) {
  if (!mainForm) return null;
  const variantIdInput = mainForm.querySelector('[name="id"]');
  return variantIdInput
    ? variantIdInput.value ||
    (variantIdInput.options &&
      variantIdInput.options[variantIdInput.selectedIndex] &&
      variantIdInput.options[variantIdInput.selectedIndex].value)
    : null;
}

function themeGetAvailabilityForm(availabilityInfo) {
  if (!availabilityInfo) return null;
  const form = availabilityInfo.querySelector('form[action*="/cart/add"]');
  if (form) {
    return form;
  }
  const addButton = availabilityInfo.querySelector(
    '.product-availability-info__add-button[data-form-id]'
  );
  const formId = addButton ? addButton.getAttribute('data-form-id') : null;
  if (formId) {
    const formById = document.getElementById(formId);
    if (formById) {
      return formById;
    }
  }
  return null;
}

function themeApplyQuantityToForm(mainForm, quantity) {
  if (!mainForm) return;
  mainForm.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = quantity;
    input.setAttribute('value', String(quantity));
  });
  if (mainForm.elements && mainForm.elements.namedItem('quantity')) {
    mainForm.elements.namedItem('quantity').value = quantity;
  }
  for (let i = 0; i < mainForm.elements.length; i++) {
    if (mainForm.elements[i].name === 'quantity') {
      mainForm.elements[i].value = quantity;
    }
  }
}

function themeSyncAvailabilityQuantityToForm(mainForm, availabilityInfo) {
  if (!mainForm || !availabilityInfo) return 0;
  const availabilityQuantityInput = availabilityInfo.querySelector('input[name="quantity"]');
  let quantity = availabilityQuantityInput
    ? themeNormalizeAvailabilityQuantityInput(availabilityQuantityInput)
    : 0;

  if (availabilityQuantityInput) {
    availabilityQuantityInput.value = quantity;
    availabilityQuantityInput.setAttribute('value', String(quantity));
  }
  mainForm.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = quantity;
    input.setAttribute('value', quantity);
  });
  if (mainForm.elements && mainForm.elements.namedItem('quantity')) {
    mainForm.elements.namedItem('quantity').value = quantity;
  }
  for (let i = 0; i < mainForm.elements.length; i++) {
    if (mainForm.elements[i].name === 'quantity') {
      mainForm.elements[i].value = quantity;
    }
  }
  return quantity;
}

function themeSumCartQuantity(cart) {
  if (!cart) return 0;
  if (typeof cart.item_count === 'number' && !isNaN(cart.item_count)) {
    return cart.item_count;
  }
  if (!cart.items || !cart.items.length) return 0;
  return cart.items.reduce(function (sum, item) {
    return sum + (parseInt(item.quantity, 10) || 0);
  }, 0);
}

function themeGetVariantQtyInCart(cart, variantId) {
  if (!cart || !cart.items || !variantId) return 0;
  var total = 0;
  cart.items.forEach(function (item) {
    if (String(item.variant_id) === String(variantId)) {
      total += parseInt(item.quantity, 10) || 0;
    }
  });
  return total;
}

function themeAlertProductQuantityLimitExceeded(quantityLimit, inCart, requestedQty) {
  var remaining = Math.max(0, quantityLimit - inCart);
  var tpl = window.languages && window.languages.productQuantityLimitCartFull;
  if (inCart > 0 && requestedQty > remaining) {
    var exceedTpl =
      (window.languages && window.languages.productQuantityLimitWouldExceed) ||
      'This item is limited to [[limit]] units per order. You have [[inCart]] in your cart and can add at most [[remaining]] more.';
    alert(
      String(exceedTpl)
        .replace(/\[\[limit\]\]/g, String(quantityLimit))
        .replace(/\[\[inCart\]\]/g, String(inCart))
        .replace(/\[\[remaining\]\]/g, String(remaining))
    );
    return;
  }
  var limitMsg = tpl
    ? String(tpl).replace(/\[\[limit\]\]/g, String(quantityLimit))
    : 'This item is limited to ' + quantityLimit + ' units per order.';
  alert(limitMsg);
}

function themeIsPtwGiftWrapRequested() {
  const checkbox = document.getElementById('ptw-gift-needed');
  return Boolean(checkbox && checkbox.checked);
}

function themeCapturePtwGiftWrapState() {
  if (!themeIsPtwGiftWrapRequested()) {
    return null;
  }

  const variantInput = document.getElementById('ptw-variant-id');
  const variantId = variantInput ? String(variantInput.value || '').trim() : '';
  if (!variantId) {
    return null;
  }

  const noteEl = document.getElementById('ptw-text-message');
  const nameEl = document.getElementById('ptw-productname');

  return {
    variantId: variantId,
    giftNote: noteEl ? noteEl.value : '',
    prodName: nameEl ? nameEl.value : ''
  };
}

function themeUncheckPtwGiftWrap() {
  const checkbox = document.getElementById('ptw-gift-needed');
  if (checkbox) {
    checkbox.checked = false;
  }
}

function themeBuildProductLineItemFromForm(mainForm, quantity, FormClass) {
  const serialized = FormClass.serialize(mainForm);
  const item = {
    id: serialized.id,
    quantity: quantity
  };
  if (serialized.properties && typeof serialized.properties === 'object') {
    item.properties = serialized.properties;
  }
  if (serialized.selling_plan != null && serialized.selling_plan !== '') {
    item.selling_plan = serialized.selling_plan;
  }
  return item;
}

/**
 * 商品フォーム + ギフトラッピングを1リクエスト用の cart/add ボディに組み立てる
 */
function themeBuildAvailabilityCartAddBody(mainForm, quantity, giftWrapState, FormClass) {
  if (!giftWrapState || !giftWrapState.variantId) {
    return FormClass.serialize(mainForm);
  }

  const productItem = themeBuildProductLineItemFromForm(mainForm, quantity, FormClass);
  const giftVariantId = parseInt(giftWrapState.variantId, 10) || giftWrapState.variantId;

  return {
    items: [
      productItem,
      {
        id: giftVariantId,
        quantity: quantity,
        properties: {
          'Gift Note': giftWrapState.giftNote || '',
          'Product Name': giftWrapState.prodName || ''
        }
      }
    ]
  };
}

function themeFinalizeAvailabilityAddSuccess(
  triggerButton,
  mainForm,
  result,
  options
) {
  const quantity = options.quantity;
  const giftWrapState = options.giftWrapState;
  const giftQty = giftWrapState ? quantity : 0;
  const validation = options.validation;
  const quantityLimit = options.quantityLimit;
  const inventoryLimited = options.inventoryLimited;
  const skippedFromLimit = options.skippedFromLimit;
  const skippedFromCart = options.skippedFromCart;

  if (giftWrapState) {
    themeUncheckPtwGiftWrap();
  }

  return themeFetchCartState().then(function (cart) {
    window.themeUpdateCartCountCache(cart.item_count || 0);
    themeDispatchProductAdded(triggerButton, mainForm, true, quantity + giftQty);

    if (inventoryLimited) {
      themeShowProductCartNotice(themeGetCartAvailabilityLimitedMessage(quantity));
    } else if (validation.productLimitLimited) {
      themeShowProductCartNotice(
        themeGetCartQuantityLimitLimitedMessage(
          quantity,
          validation.quantityLimit || quantityLimit,
          skippedFromLimit
        )
      );
    } else if (validation.cartLimitLimited && skippedFromCart > 0) {
      themeShowProductCartNotice(
        themeGetCartQuantityLimitLimitedMessage(
          quantity,
          window.themeGetCartMaxLineItems(),
          skippedFromCart
        )
      );
    }

    if (window.theme && (window.theme.pageType === 'cart' || window.theme.cartType === 'page')) {
      window.location.href = window.routes.cartUrl;
      return result;
    }
    if (window.theme && window.theme.cartType === 'drawer') {
      document.dispatchEvent(new CustomEvent('modal:close'));
    }
    return result;
  });
}

/**
 * カート追加数量の検証（カート内既存数量 + 追加数量で上限判定）
 * @returns {{ ok: true, quantity: number } | { ok: false, reason: string }}
 */
function themeValidateCartAddQuantity(
  cart,
  variantId,
  requestedQty,
  quantityLimit,
  cartMaxItems,
  giftWrapRequested
) {
  var requested = parseInt(requestedQty, 10);
  if (isNaN(requested) || requested < 1) {
    return { ok: false, reason: 'zero' };
  }

  var inCartVariant = themeGetVariantQtyInCart(cart, variantId);
  var totalInCart = themeSumCartQuantity(cart);
  var perProductMax =
    quantityLimit != null && !isNaN(parseInt(quantityLimit, 10)) && parseInt(quantityLimit, 10) > 0
      ? parseInt(quantityLimit, 10)
      : null;
  var cartMax =
    cartMaxItems != null && !isNaN(parseInt(cartMaxItems, 10))
      ? parseInt(cartMaxItems, 10)
      : window.themeGetCartMaxLineItems();

  var qty = requested;
  var productLimitLimited = false;
  var cartLimitLimited = false;

  if (perProductMax != null) {
    if (inCartVariant >= perProductMax) {
      return {
        ok: false,
        reason: 'product_limit_full',
        quantityLimit: perProductMax,
        inCart: inCartVariant,
        requested: requested
      };
    }
    var productRemaining = perProductMax - inCartVariant;
    if (qty > productRemaining) {
      qty = productRemaining;
      productLimitLimited = true;
    }
  }

  var giftReservedQty = giftWrapRequested ? qty : 0;

  if (totalInCart + qty + giftReservedQty > cartMax) {
    var cartRemaining = Math.max(0, cartMax - totalInCart - giftReservedQty);
    if (cartRemaining <= 0) {
      return {
        ok: false,
        reason: 'cart_max_exceed',
        cartMax: cartMax,
        totalInCart: totalInCart,
        requested: requested,
        allowed: 0
      };
    }
    if (qty > cartRemaining) {
      qty = cartRemaining;
      cartLimitLimited = true;
    }
  }

  if (qty < 1) {
    return { ok: false, reason: 'zero' };
  }

  return {
    ok: true,
    quantity: qty,
    requested: requested,
    productLimitLimited: productLimitLimited,
    cartLimitLimited: cartLimitLimited,
    quantityLimit: perProductMax,
    inCart: inCartVariant
  };
}

function themeFetchCartState() {
  if (!window.routes || !window.routes.cartUrl) {
    return Promise.resolve({ item_count: 0, items: [] });
  }
  return fetch(window.routes.cartUrl + '.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(function (response) {
      if (response.ok) {
        return response.json();
      }
      return { item_count: 0, items: [] };
    })
    .catch(function () {
      return { item_count: 0, items: [] };
    });
}

function themeDispatchProductAdded(button, form, responseOk, quantityAdded) {
  const quantity =
    quantityAdded != null && !isNaN(parseInt(quantityAdded, 10))
      ? parseInt(quantityAdded, 10)
      : parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1;
  const variantInput = form.querySelector('[name="id"]');
  const variantId = variantInput ? variantInput.value : null;
  const event = new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      button: button,
      variant: variantId,
      quantity: quantity,
      productAdded: responseOk
    }
  });
  document.documentElement.dispatchEvent(event);
}

function themeAddProductFormToCart(mainForm, triggerButton, options) {
  const FormClass = typeof window.Form !== 'undefined' ? window.Form : typeof Form !== 'undefined' ? Form : null;
  if (!FormClass || !FormClass.serialize) {
    return Promise.reject(new Error('Form.serialize is not available'));
  }

  const giftWrapState = options && options.giftWrapState ? options.giftWrapState : null;
  const giftWrapRequested = Boolean(giftWrapState);

  const availabilityInfo = themeResolveAvailabilityInfo(
    triggerButton && triggerButton.closest
      ? triggerButton.closest('.product-availability-info')
      : null,
    mainForm
  );
  const variantIdInput = mainForm.querySelector('[name="id"]');
  const variantId = variantIdInput
    ? variantIdInput.value ||
    (variantIdInput.options &&
      variantIdInput.options[variantIdInput.selectedIndex] &&
      variantIdInput.options[variantIdInput.selectedIndex].value)
    : null;
  const quantityLimit = themeGetProductQuantityLimit(availabilityInfo, mainForm);

  return themeFetchCartState().then(function (cart) {
    const requestedQuantity = themeSyncAvailabilityQuantityToForm(mainForm, availabilityInfo);
    if (requestedQuantity < 1) {
      return Promise.resolve(null);
    }

    const validation = themeValidateCartAddQuantity(
      cart,
      variantId,
      requestedQuantity,
      quantityLimit,
      window.themeGetCartMaxLineItems(),
      giftWrapRequested
    );

    if (!validation.ok) {
      if (validation.reason === 'cart_max_exceed') {
        window.themeShowCartFullPopup();
      } else if (validation.reason === 'product_limit_full') {
        themeAlertProductQuantityLimitExceeded(
          validation.quantityLimit || quantityLimit,
          validation.inCart || 0,
          validation.requested || requestedQuantity
        );
      }
      return Promise.resolve(null);
    }

    const variant = themeResolveProductVariant(variantId);
    const inventoryResult = themeGetInventoryAddableQuantity(
      cart,
      variantId,
      variant,
      validation.quantity
    );

    if (inventoryResult.remaining !== null && inventoryResult.remaining <= 0) {
      themeShowProductCartNotice(themeGetCartInventoryMaxInCartMessage());
      return Promise.resolve(null);
    }

    const quantity = inventoryResult.addQty;
    const inventoryLimited = inventoryResult.limited;
    const requestedQty = validation.requested || requestedQuantity;
    const skippedFromLimit = validation.productLimitLimited
      ? Math.max(0, requestedQty - quantity)
      : 0;
    const skippedFromCart = validation.cartLimitLimited
      ? Math.max(0, requestedQty - quantity)
      : 0;
    themeApplyQuantityToForm(mainForm, quantity);

    if (!inventoryLimited && !validation.productLimitLimited && !validation.cartLimitLimited) {
      themeHideProductCartNotice();
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    window.__themeSkipCartAddFetchGuard = true;

    const addBody = themeBuildAvailabilityCartAddBody(
      mainForm,
      quantity,
      giftWrapState,
      FormClass
    );

    return fetch(`${window.routes.cartAddUrl}.js`, {
      body: JSON.stringify(addBody),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (content) {
            return { response: response, content: content };
          });
      })
      .then(function (result) {
        if (result.response.ok) {
          return themeFinalizeAvailabilityAddSuccess(triggerButton, mainForm, result, {
            quantity: quantity,
            giftWrapState: giftWrapState,
            validation: validation,
            quantityLimit: quantityLimit,
            inventoryLimited: inventoryLimited,
            skippedFromLimit: skippedFromLimit,
            skippedFromCart: skippedFromCart
          });
        }
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        themeDispatchProductAdded(triggerButton, mainForm, false);
        const rawDescription = result.content && result.content.description;
        let errorMessage = window.themeGetSafeCartDescription(rawDescription);
        if (themeIsMaxQuantityInCartDescription(rawDescription)) {
          errorMessage = themeGetCartInventoryMaxInCartMessage();
        }
        themeShowProductCartNotice(errorMessage);
        return result;
      })
      .catch(function (error) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        console.error('[product-availability-info__add-button]', error);
        const cartAddRetryMsg = window.languages && window.languages.productCartAddErrorRetry;
        const retryMessage = cartAddRetryMsg || 'Something went wrong. Please try again.';
        themeShowProductCartNotice(retryMessage);
        throw error;
      });
  });
}

/** buy-button / cart/add 用: DOMContentLoaded 前に登録（custom.js は type=module のため） */
(function themeInitCartLineLimitGuards() {
  function themeEscapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  window.themeEscapeHtml = themeEscapeHtml;

  function themeStripHtmlTags(str) {
    return String(str).replace(/<[^>]*>/g, '');
  }

  function themePatchInnerHtmlForUntrustedStrings() {
    var descriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
    if (!descriptor || typeof descriptor.set !== 'function') {
      return;
    }
    if (Element.prototype.__themeInnerHtmlPatched) {
      return;
    }
    var nativeSet = descriptor.set;
    var nativeGet = descriptor.get;

    Object.defineProperty(Element.prototype, 'innerHTML', {
      configurable: true,
      enumerable: descriptor.enumerable,
      get: nativeGet,
      set: function (html) {
        if (this.classList && this.classList.contains('cart__status-message')) {
          var htmlStr = html == null ? '' : String(html);
          var isSuccess = /alert--success/.test(htmlStr);
          var hasContainer = /class=["']container["']/.test(htmlStr);
          var msgMatch = htmlStr.match(/<p[^>]*>([\s\S]*?)<\/p>/i);
          var rawMsg = themeStripHtmlTags(msgMatch ? msgMatch[1] : htmlStr);
          var safeMsg = window.themeGetSafeCartDescription(rawMsg);

          var alertEl = document.createElement('div');
          alertEl.className = 'alert ' + (isSuccess ? 'alert--success' : 'alert--error');
          var paragraph = document.createElement('p');
          if (hasContainer) {
            paragraph.className = 'container';
          }
          paragraph.textContent = safeMsg;
          alertEl.appendChild(paragraph);
          this.replaceChildren(alertEl);
          return;
        }

        if (
          this.classList &&
          this.classList.contains('expandable-content__toggle-text')
        ) {
          this.textContent = html == null ? '' : String(html);
          return;
        }

        nativeSet.call(this, html);
      }
    });
    Element.prototype.__themeInnerHtmlPatched = true;
  }

  function themeGetCartAddFailedMessage() {
    return (
      (window.languages && window.languages.productCartAddFailed) ||
      'Could not add this product to your cart.'
    );
  }

  function themeLooksLikeUnsafeCartDescription(str) {
    return /<|>|javascript:|on\w+\s*=/i.test(str);
  }

  function themeIsAvailabilityLimitedCartDescription(desc) {
    const s = String(desc).trim();
    if (!s || themeLooksLikeUnsafeCartDescription(s)) {
      return false;
    }
    const patterns = [
      /^You can only add \d+/i,
      /^You can't add more/i,
      /^You cannot add more/i,
      /^Only available quantity items were added to your cart\.?$/i,
      /^Only \d+ (quantity|quantities|item|items) (was|were) added to your cart due to availability\.?$/i,
      /^The maximum quantity of this item is already in your cart\.?$/i,
      /^All \d+ .+ (is|are) in your cart/i
    ];
    return patterns.some(function (pattern) {
      return pattern.test(s);
    });
  }

  function themeIsAllowedCartDescription(desc) {
    const s = String(desc).trim();
    if (!s || themeLooksLikeUnsafeCartDescription(s)) {
      return false;
    }
    if (
      s === themeGetCartAddFailedMessage() ||
      s === themeGetCartInventoryMaxInCartMessage() ||
      themeIsAvailabilityLimitedCartDescription(s)
    ) {
      return true;
    }
    const patterns = [
      /^Cart is full$/i,
      /^The product .+ is already sold out/i,
      /^This product is already sold out/i,
      /^Variant .+ is already sold out/i,
      /^The product '.+' is already sold out/i,
      /^Insufficient stock/i,
      /^You must purchase at least \d+/i,
      /^Cannot find variant/i,
      /^カートに追加/,
      /^商品をカートに追加できません/,
      /^売り切れ/,
      /^在庫が不足/,
      /^この商品は/,
      /^ご注文可能な数量/
    ];
    return patterns.some(function (pattern) {
      return pattern.test(s);
    });
  }

  window.themeGetSafeCartDescription = function (desc) {
    const raw = desc == null ? '' : String(desc).trim();
    if (!raw) {
      return themeGetCartAddFailedMessage();
    }
    if (themeIsAvailabilityLimitedCartDescription(raw)) {
      const qtyMatch = raw.match(/\d+/);
      return themeGetCartAvailabilityLimitedMessage(
        qtyMatch ? parseInt(qtyMatch[0], 10) : 1
      );
    }
    if (themeIsAllowedCartDescription(raw)) {
      return raw;
    }
    return themeGetCartAddFailedMessage();
  };

  window.themeGetSafeCartDescriptionHtml = function (desc) {
    return themeEscapeHtml(window.themeGetSafeCartDescription(desc));
  };

  function themeSanitizeCartJsonBody(data) {
    if (!data || typeof data !== 'object') {
      return data;
    }
    if (typeof data.description !== 'string') {
      return data;
    }
    return Object.assign({}, data, {
      description: window.themeGetSafeCartDescriptionHtml(data.description)
    });
  }

  function themeSanitizeShippingRatesErrorBody(data) {
    if (data && Array.isArray(data.shipping_rates)) {
      return data;
    }
    if (!data || typeof data !== 'object') {
      return themeBuildGenericShippingErrorBody();
    }
    const labels = {
      zip: (window.languages && window.languages.shippingEstimatorFieldZip) || 'Zip code',
      country:
        (window.languages && window.languages.shippingEstimatorFieldCountry) || 'Country',
      province:
        (window.languages && window.languages.shippingEstimatorFieldProvince) || 'Province'
    };
    const out = {};
    ['zip', 'country', 'province'].forEach(function (key) {
      if (data[key] == null) {
        return;
      }
      let val = data[key];
      if (Array.isArray(val)) {
        val = val.filter(Boolean).join(' ');
      } else {
        val = String(val);
      }
      val = val.trim();
      if (!val || themeLooksLikeUnsafeCartDescription(val)) {
        return;
      }
      out[labels[key]] = themeEscapeHtml(val);
    });
    if (Object.keys(out).length === 0) {
      return themeBuildGenericShippingErrorBody();
    }
    return out;
  }

  function themeBuildGenericShippingErrorBody() {
    const label =
      (window.languages && window.languages.shippingEstimatorFieldZip) || 'Zip code';
    const msg =
      (window.languages && window.languages.shippingEstimatorFieldError) ||
      'Please check your entry and try again.';
    const out = {};
    out[label] = themeEscapeHtml(msg);
    return out;
  }

  function themeGetFetchUrl(input) {
    if (typeof input === 'string') {
      return input;
    }
    return (input && input.url) || '';
  }

  function themeGetFetchMethod(input, init) {
    return ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
  }

  function themeShouldSanitizeCartJsonResponse(url, method, response) {
    if (!response || response.ok) {
      return false;
    }
    const u = url.toLowerCase();
    return (
      method === 'POST' &&
      (u.indexOf('/cart/add') !== -1 || u.indexOf('/cart/change') !== -1)
    );
  }

  function themeIsShippingRatesJsonRequest(url, method) {
    return (
      method === 'GET' && url.toLowerCase().indexOf('shipping_rates.json') !== -1
    );
  }

  function themeShouldSanitizeShippingRatesResponse(url, method, response) {
    if (!response || response.ok || !themeIsShippingRatesJsonRequest(url, method)) {
      return false;
    }
    return true;
  }

  function themeShouldSanitizeShippingRatesOkResponse(url, method, response) {
    if (!response || !response.ok || !themeIsShippingRatesJsonRequest(url, method)) {
      return false;
    }
    return true;
  }

  function themeSanitizeShippingRatesSuccessBody(data) {
    if (!data || !Array.isArray(data.shipping_rates)) {
      return data;
    }
    return Object.assign({}, data, {
      shipping_rates: data.shipping_rates.map(function (item) {
        if (!item || typeof item !== 'object') {
          return item;
        }
        var safe = Object.assign({}, item);
        if (item.name != null) {
          safe.name = themeEscapeHtml(String(item.name));
        }
        return safe;
      })
    });
  }

  function themeCloneResponseWithJson(response, data) {
    return new Response(JSON.stringify(data), {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers
    });
  }

  function themeApplyFetchResponseSanitization(nativePromise, url, method) {
    return nativePromise.then(function (response) {
      if (themeShouldSanitizeCartJsonResponse(url, method, response)) {
        return response
          .clone()
          .json()
          .catch(function () {
            return null;
          })
          .then(function (data) {
            if (!data) {
              return response;
            }
            return themeCloneResponseWithJson(
              response,
              themeSanitizeCartJsonBody(data)
            );
          });
      }
      if (themeShouldSanitizeShippingRatesResponse(url, method, response)) {
        return response
          .clone()
          .json()
          .catch(function () {
            return null;
          })
          .then(function (data) {
            if (!data) {
              return response;
            }
            return themeCloneResponseWithJson(
              response,
              themeSanitizeShippingRatesErrorBody(data)
            );
          });
      }
      if (themeShouldSanitizeShippingRatesOkResponse(url, method, response)) {
        return response
          .clone()
          .json()
          .catch(function () {
            return null;
          })
          .then(function (data) {
            if (!data) {
              return response;
            }
            return themeCloneResponseWithJson(
              response,
              themeSanitizeShippingRatesSuccessBody(data)
            );
          });
      }
      return response;
    });
  }

  function themeSanitizeCartStatusMessageNode(root) {
    if (!root || !root.querySelector) {
      return;
    }
    const paragraph = root.querySelector('.alert p, .alert--error p, .alert--success p');
    if (!paragraph) {
      return;
    }
    const safeText = window.themeGetSafeCartDescription(paragraph.textContent || '');
    if (paragraph.textContent !== safeText) {
      paragraph.textContent = safeText;
    }
  }

  function themeSanitizeShippingEstimatorResults(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }
    root.querySelectorAll('.shipping-estimator__results li').forEach(function (item) {
      const safeText = item.textContent || '';
      if (themeLooksLikeUnsafeCartDescription(safeText)) {
        item.textContent =
          (window.languages && window.languages.shippingEstimatorFieldError) ||
          'Please check your entry and try again.';
      }
    });
  }

  function themeInitApiErrorDomObservers() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }
          if (node.matches && node.matches('.cart__status-message')) {
            themeSanitizeCartStatusMessageNode(node);
          }
          if (node.querySelectorAll) {
            node
              .querySelectorAll('.cart__status-message')
              .forEach(themeSanitizeCartStatusMessageNode);
          }
          if (node.matches && node.matches('.shipping-estimator__results')) {
            themeSanitizeShippingEstimatorResults(node);
          }
          if (node.querySelectorAll) {
            node
              .querySelectorAll('.shipping-estimator__results')
              .forEach(themeSanitizeShippingEstimatorResults);
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  themePatchInnerHtmlForUntrustedStrings();

  if (document.documentElement) {
    themeInitApiErrorDomObservers();
  }

  function parseCartAddPayload(init) {
    if (!init || !init.body || typeof init.body !== 'string') {
      return null;
    }
    try {
      return JSON.parse(init.body);
    } catch (err) {
      return null;
    }
  }

  function parseCartAddQuantity(init) {
    const parsed = parseCartAddPayload(init);
    return parsed ? parseInt(parsed.quantity, 10) || 1 : 1;
  }

  function isCartAddPostRequest(input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    return Boolean(url && url.indexOf('/cart/add') !== -1 && method === 'POST');
  }

  document.addEventListener(
    'click',
    function (e) {
      if (window.__themeSkipProductCartLineLimit) {
        window.__themeSkipProductCartLineLimit = false;
        window.__themeSkipCartAddFetchGuard = true;
        return;
      }
      const buyRoot = e.target.closest('buy-button');
      if (!buyRoot) return;
      const form = buyRoot.closest('form[action*="/cart/add"]');
      if (!form) return;

      if (window.__themeBuyButtonLimitBusy) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      const qtyInput = form.querySelector('[name="quantity"]');
      let qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (qty < 1) qty = 1;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      window.__themeBuyButtonLimitBusy = true;

      const variantIdInput = form.querySelector('[name="id"]');
      const variantId = variantIdInput ? variantIdInput.value : null;
      const quantityLimit = themeGetBuyButtonQuantityLimit(buyRoot, form);

      themeValidateListingCartAdd(variantId, qty, quantityLimit, false)
        .then(function (validation) {
          if (!validation.ok) {
            themeApplyListingCartAddValidationFailure(validation, quantityLimit, qty);
            return;
          }

          if (validation.quantity !== qty) {
            themeSyncBuyButtonFormQuantity(form, validation.quantity);
          }

          window.__themeSkipProductCartLineLimit = true;
          window.__themeSkipCartAddFetchGuard = true;
          const submitBtn = buyRoot.querySelector('button[type="submit"]');
          if (submitBtn) submitBtn.click();
        })
        .finally(function () {
          window.__themeBuyButtonLimitBusy = false;
        });
    },
    true
  );

  if (window.__themeCartAddFetchGuard) return;
  window.__themeCartAddFetchGuard = true;
  const nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = themeGetFetchUrl(input);
    const method = themeGetFetchMethod(input, init);

    if (window.__themeSkipCartAddFetchGuard) {
      window.__themeSkipCartAddFetchGuard = false;
      return themeApplyFetchResponseSanitization(nativeFetch(input, init), url, method);
    }
    if (!isCartAddPostRequest(input, init)) {
      return themeApplyFetchResponseSanitization(nativeFetch(input, init), url, method);
    }
    const payload = parseCartAddPayload(init);
    const qty = payload ? parseInt(payload.quantity, 10) || 1 : 1;
    const variantId = payload && payload.id != null ? payload.id : null;
    if (
      payload &&
      (
        payload.properties ||
        Array.isArray(payload.items)
      )
    ) {
      return themeApplyFetchResponseSanitization(nativeFetch(input, init), url, method);
    }
    const availabilityInfo = themeResolveAvailabilityInfo(
      document.querySelector('.product-availability-info'),
      null
    );
    const quantityLimit = themeResolveQuantityLimitForCartAdd(variantId, availabilityInfo);

    return themeFetchCartState().then(function (cart) {
      const validation = themeValidateCartAddQuantity(
        cart,
        variantId,
        qty,
        quantityLimit,
        window.themeGetCartMaxLineItems(),
        themeIsPtwGiftWrapRequested()
      );

      if (!validation.ok) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        if (validation.reason === 'cart_max_exceed') {
          window.themeShowCartFullPopup();
        } else if (validation.reason === 'product_limit_full') {
          themeAlertProductQuantityLimitExceeded(
            validation.quantityLimit || quantityLimit,
            validation.inCart || 0,
            validation.requested || qty
          );
        }
        return Promise.resolve(
          new Response(
            JSON.stringify({
              description: window.themeGetSafeCartDescriptionHtml('Cart is full'),
              status: 422
            }),
            {
              status: 422,
              headers: { 'Content-Type': 'application/json' }
            }
          )
        );
      }

      if (payload && validation.quantity !== qty) {
        payload.quantity = validation.quantity;
        init = Object.assign({}, init, { body: JSON.stringify(payload) });
      }

      return themeApplyFetchResponseSanitization(nativeFetch(input, init), url, method);
    });
  };
})();

/** product-availability-info の Add to Cart（DOMContentLoaded 非依存・連打防止） */
(function themeInitAvailabilityAddButton() {
  function runAvailabilityAdd(addButton, availabilityInfo) {
    const mainForm = themeGetAvailabilityForm(availabilityInfo);
    if (!mainForm) {
      console.error('[product-availability-info__add-button] Form not found');
      return;
    }

    if (window.__themeAvailabilityAddInflight) {
      return;
    }

    const giftWrapState = themeCapturePtwGiftWrapState();

    window.__themeAvailabilityAddBusy = true;
    themeSetAvailabilityAddButtonBusy(addButton, true);

    window.__themeAvailabilityAddInflight = themeAddProductFormToCart(mainForm, addButton, {
      giftWrapState: giftWrapState
    })
      .then(function (result) {
        if (!result || !result.response || !result.response.ok) {
          themeSetAvailabilityAddButtonBusy(addButton, false);
        }
        return result;
      })
      .catch(function () {
        themeSetAvailabilityAddButtonBusy(addButton, false);
      })
      .finally(function () {
        window.__themeAvailabilityAddInflight = null;
        window.__themeAvailabilityAddBusy = false;
      });
  }

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form || !form.matches('.product-form--availability')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const availabilityInfo = form.closest('.product-availability-info');
      const addButton = form.querySelector('.product-availability-info__add-button');
      if (
        !addButton ||
        addButton.disabled ||
        addButton.dataset.themeAdding === 'true' ||
        window.__themeAvailabilityAddBusy ||
        window.__themeAvailabilityAddInflight
      ) {
        return;
      }

      runAvailabilityAdd(addButton, availabilityInfo);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const addButton = e.target.closest('.product-availability-info__add-button');
      if (!addButton) {
        return;
      }

      if (addButton.type === 'submit') {
        // Wrappin 等のバブルフェーズ click リスナーを抑止（submit ハンドラが処理する）
        e.stopPropagation();
        return;
      }

      if (
        addButton.disabled ||
        addButton.dataset.themeAdding === 'true' ||
        window.__themeAvailabilityAddBusy ||
        window.__themeAvailabilityAddInflight
      ) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const availabilityInfo = addButton.closest('.product-availability-info');
      runAvailabilityAdd(addButton, availabilityInfo);
    },
    true
  );

  document.addEventListener('product:added', function () {
    themeReleaseAvailabilityAddButtons();
  });
})();

if (Animation && Accessibility) {
  document.addEventListener('click', function (event) {
    const toggleButton = event.target.closest('[data-action="toggle-announcement-bar"]');
    if (toggleButton) {
      const announcementBar = toggleButton.closest('.announcement-bar.custom-announcement-bar');
      if (announcementBar) {
        Animation.slideUp(announcementBar, () => {
          Accessibility.removeTrapFocus(announcementBar, "announcement-bar");
        });
      }
    }
  });
}

// 2025/11/30 - モバイルメニュークリック時のメニューオープン（by Watanabe）
document.addEventListener('click', function (event) {
  const toggleButton = event.target.closest('[data-action="toggle-menu"], [data-action="toggle-search"]');
  if (toggleButton) {
    const mobileMenus = document.querySelectorAll('.custom-js-menu-hidden');
    mobileMenus.forEach(function (mobileMenu) {
      mobileMenu.classList.toggle('custom-hidden');
    });

    // data-action="toggle-search"がクリックされたときの処理
    if (toggleButton.getAttribute('data-action') === 'toggle-search') {
      // 元々toggle-menuだったボタンがtoggle-searchに変更されているかどうかを確認
      const originalMenuToggleButton = document.querySelector('.header__mobile-nav-toggle[data-action="toggle-search"], .header__desktop-nav-toggle[data-action="toggle-search"]');

      if (originalMenuToggleButton) {
        // 既にtoggle-searchに変更されている場合は、toggle-menuに戻す
        originalMenuToggleButton.setAttribute('data-action', 'toggle-menu');
        originalMenuToggleButton.setAttribute('aria-expanded', 'false');
      } else {
        // まだtoggle-menuのままの場合は、toggle-searchに変更
        const menuToggleButton = document.querySelector('[data-action="toggle-menu"]');
        if (menuToggleButton) {
          menuToggleButton.setAttribute('data-action', 'toggle-search');
          menuToggleButton.setAttribute('aria-expanded', 'true');
        }
      }
    }
  }
});

// ツールチップ: ESCキーでフォーカスを外してツールチップを閉じる（キーボードアクセシビリティ）
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape' && event.key !== 'Esc') {
    return;
  }
  var active = document.activeElement;
  var isTooltipTrigger =
    active && (
      active.hasAttribute && active.hasAttribute('data-tooltip') ||
      (active.classList && active.classList.contains('custom-product-item__label'))
    );
  if (isTooltipTrigger) {
    active.blur();
    event.preventDefault();
    return;
  }
  // Member Price ? ツールチップを閉じる
  var openTrigger = document.querySelector('.price-list__member-price-tooltip-trigger[aria-expanded="true"]');
  if (openTrigger) {
    var tooltipId = openTrigger.getAttribute('aria-controls');
    var tooltip = tooltipId ? document.getElementById(tooltipId) : null;
    if (tooltip) {
      tooltip.setAttribute('hidden', '');
      openTrigger.setAttribute('aria-expanded', 'false');
    }
    event.preventDefault();
  }
});

// Member Price ? ツールチップ: クリックで開閉・外クリックで閉じる・Closeボタンで閉じる
document.addEventListener('click', function (event) {
  var closeBtn = event.target.closest('[data-member-price-tooltip-close]');
  if (closeBtn) {
    var tooltip = closeBtn.closest('.price-list__member-price-tooltip');
    if (tooltip && tooltip.id) {
      var trigger = document.querySelector('[aria-controls="' + tooltip.id + '"]');
      if (trigger) {
        tooltip.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
      }
    }
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  var trigger = event.target.closest('[data-member-price-tooltip-trigger]');
  var tooltipId = trigger ? trigger.getAttribute('aria-controls') : null;
  var tooltip = tooltipId ? document.getElementById(tooltipId) : null;

  if (trigger && tooltip) {
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      tooltip.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    } else {
      document.querySelectorAll('.price-list__member-price-tooltip-trigger[aria-expanded="true"]').forEach(function (t) {
        var id = t.getAttribute('aria-controls');
        var tip = id ? document.getElementById(id) : null;
        if (tip) {
          tip.setAttribute('hidden', '');
          t.setAttribute('aria-expanded', 'false');
        }
      });
      tooltip.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
    }
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  var openTrigger = document.querySelector('.price-list__member-price-tooltip-trigger[aria-expanded="true"]');
  if (openTrigger && !event.target.closest('.price-list__member-price-tooltip-wrapper')) {
    var id = openTrigger.getAttribute('aria-controls');
    var openTooltip = id ? document.getElementById(id) : null;
    if (openTooltip) {
      openTooltip.setAttribute('hidden', '');
      openTrigger.setAttribute('aria-expanded', 'false');
    }
  }
});

function closeAllCustomNavMenus() {
  var navBar = document.querySelector('.custom-nav-bar');
  if (!navBar) {
    return false;
  }

  var openMenus = navBar.querySelectorAll('.mega-menu[aria-hidden="false"], .nav-dropdown[aria-hidden="false"]');
  var openLinks = navBar.querySelectorAll(
    '.custom-nav-bar__link[aria-expanded="true"], .nav-dropdown__link[aria-expanded="true"], [data-type="menuitem"][aria-expanded="true"]'
  );

  if (openMenus.length === 0 && openLinks.length === 0) {
    return false;
  }

  openLinks.forEach(function (link) {
    link.setAttribute('aria-expanded', 'false');

    var parentItem = link.closest('.custom-nav-bar__item, .nav-dropdown__item');
    if (parentItem) {
      parentItem.classList.remove('is-dropdown-open');
    }
  });

  openMenus.forEach(function (menu) {
    menu.setAttribute('aria-hidden', 'true');

    var parentMenu = menu.closest('[data-type="menu"]');
    if (parentMenu) {
      parentMenu.classList.remove('nav-dropdown--glued');
    }
  });

  navBar.querySelectorAll('.is-dropdown-open').forEach(function (dropdown) {
    dropdown.classList.remove('is-dropdown-open');
    dropdown.querySelectorAll('[aria-hidden="false"]').forEach(function (nestedMenu) {
      nestedMenu.setAttribute('aria-hidden', 'true');
    });
    dropdown.querySelectorAll('[aria-expanded="true"]').forEach(function (nestedLink) {
      nestedLink.setAttribute('aria-expanded', 'false');
    });
  });

  return true;
}

// 2026/01/25 - メガメニュー展開時にESCキーで全体を閉じる機能（by Watanabe）
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape' && event.key !== 'Esc') {
    return;
  }

  closeAllCustomNavMenus();
});

// 2026/07/07 - デスクトップナビ: メニュー外クリックで全体を閉じる（hover 時は theme.js が閉じないため）
document.addEventListener('click', function (event) {
  var navBar = document.querySelector('.custom-nav-bar');
  if (!navBar || navBar.contains(event.target)) {
    return;
  }

  closeAllCustomNavMenus();
});

// 2026/05/05 - インラインナビ: トップレベルをクリックしたとき他の1階ブランチを閉じる（ネスト展開後の theme.js openItems と DOM のずれ対策）
document.addEventListener(
  'click',
  function (event) {
    var navBar = document.querySelector('.custom-nav-bar');
    if (!navBar || !navBar.contains(event.target)) {
      return;
    }

    var link = event.target.closest('a.custom-nav-bar__link[aria-haspopup]');
    if (!link) {
      return;
    }

    var linklist = navBar.querySelector('.nav-bar__linklist');
    var currentItem = link.closest('.custom-nav-bar__item');
    if (!linklist || !currentItem || currentItem.parentElement !== linklist) {
      return;
    }

    navBar.querySelectorAll('.custom-nav-bar__item').forEach(function (item) {
      if (item === currentItem) {
        return;
      }
      closeCustomNavTopLevelBranch(item);
    });
  },
  true
);

function closeCustomNavTopLevelBranch(rootItem) {
  rootItem.classList.remove('is-dropdown-open');
  rootItem.querySelectorAll('.is-dropdown-open').forEach(function (el) {
    el.classList.remove('is-dropdown-open');
  });
  rootItem.querySelectorAll('[data-type="menuitem"][aria-expanded="true"]').forEach(function (linkEl) {
    linkEl.setAttribute('aria-expanded', 'false');
  });
  rootItem.querySelectorAll('.mega-menu[aria-hidden="false"], .nav-dropdown[aria-hidden="false"]').forEach(function (menu) {
    menu.setAttribute('aria-hidden', 'true');
  });
  rootItem.querySelectorAll('[data-type="menu"]').forEach(function (menu) {
    menu.classList.remove('nav-dropdown--glued');
  });
}

// 2026/05/16 - デスクトップナビ: ドロップダウンを画面高に収める（2・3階層は fixed で横飛びのクリップを防ぐ）
(function initCustomNavDropdownViewportHeight() {
  var navBar = document.querySelector('.custom-nav-bar');
  if (!navBar || !('MutationObserver' in window)) {
    return;
  }

  var NESTED_GAP = 4;
  var VIEWPORT_EDGE = 8;
  var VIEWPORT_BOTTOM = 20;

  function isRootDropdown(dropdown) {
    return dropdown.parentElement && dropdown.parentElement.classList.contains('custom-nav-bar__item');
  }

  function isNestedFlyout(dropdown) {
    return dropdown.getAttribute('data-type') === 'menu' && !isRootDropdown(dropdown) && !!dropdown.closest('.custom-nav-dropdown');
  }

  function getAnchorMenu(dropdown) {
    var parentItem = dropdown.parentElement;
    if (!parentItem) {
      return null;
    }
    var parentMenu = parentItem.closest('[data-type="menu"].nav-dropdown');
    if (!parentMenu || parentMenu === dropdown) {
      return null;
    }
    return parentMenu;
  }

  function clearNestedPin(dropdown) {
    dropdown.classList.remove('custom-nav-dropdown--pinned', 'nav-dropdown--inverse', 'custom-nav-dropdown--scrollable');
    dropdown.style.removeProperty('position');
    dropdown.style.removeProperty('top');
    dropdown.style.removeProperty('left');
    dropdown.style.removeProperty('right');
    dropdown.style.removeProperty('max-height');
    dropdown.style.removeProperty('overflow-y');
  }

  function getDropdownContentHeight(dropdown) {
    var style = getComputedStyle(dropdown);
    var height =
      parseFloat(style.paddingTop) +
      parseFloat(style.paddingBottom) +
      (parseFloat(style.borderTopWidth) || 0) +
      (parseFloat(style.borderBottomWidth) || 0);

    Array.prototype.forEach.call(dropdown.children, function (child) {
      if (
        child.classList.contains('nav-dropdown__item') ||
        child.classList.contains('custom-nav-dropdown__item')
      ) {
        height += child.offsetHeight;
      }
    });

    return height;
  }

  function getDropdownMaxHeight(dropdown) {
    var maxHeight = parseFloat(getComputedStyle(dropdown).maxHeight);
    return isFinite(maxHeight) ? maxHeight : null;
  }

  function syncDropdownOverflow(dropdown) {
    if (!dropdown || dropdown.getAttribute('aria-hidden') === 'true') {
      return;
    }

    dropdown.classList.remove('custom-nav-dropdown--scrollable');

    var maxHeight = getDropdownMaxHeight(dropdown);
    if (maxHeight === null) {
      return;
    }

    if (getDropdownContentHeight(dropdown) > maxHeight + 1) {
      dropdown.classList.add('custom-nav-dropdown--scrollable');
    }
  }

  function scheduleSyncDropdownOverflow(dropdown) {
    requestAnimationFrame(function () {
      syncDropdownOverflow(dropdown);
    });
  }

  function updateParentDropdownOverflow(dropdown) {
    var parentMenu = getAnchorMenu(dropdown);
    if (!parentMenu || parentMenu.getAttribute('aria-hidden') === 'true') {
      return;
    }

    if (isRootDropdown(parentMenu)) {
      scheduleSyncDropdownOverflow(parentMenu);
      return;
    }

    if (isNestedFlyout(parentMenu)) {
      scheduleSyncDropdownOverflow(parentMenu);
    }
  }

  function pinNestedDropdown(dropdown) {
    var anchorMenu = getAnchorMenu(dropdown);
    if (!anchorMenu) {
      return;
    }

    dropdown.classList.add('custom-nav-dropdown--pinned');
    dropdown.classList.remove('nav-dropdown--inverse', 'custom-nav-dropdown--scrollable');

    var anchorRect = anchorMenu.getBoundingClientRect();
    var top = anchorRect.top;
    var maxHeight = window.innerHeight - top - VIEWPORT_BOTTOM;
    var openLeft = anchorRect.right + NESTED_GAP;

    dropdown.style.position = 'fixed';
    dropdown.style.top = top + 'px';
    dropdown.style.left = openLeft + 'px';
    dropdown.style.right = '';
    dropdown.style.maxHeight = Math.max(maxHeight, 120) + 'px';
    dropdown.style.setProperty('--distance-to-top', top + 'px');

    var dropdownWidth = dropdown.offsetWidth;

    if (openLeft + dropdownWidth > window.innerWidth - VIEWPORT_EDGE) {
      dropdown.classList.add('nav-dropdown--inverse');
      dropdown.style.left = Math.max(VIEWPORT_EDGE, anchorRect.left - NESTED_GAP - dropdownWidth) + 'px';
    }

    if (isRootDropdown(anchorMenu)) {
      anchorMenu.scrollLeft = 0;
    }

    scheduleSyncDropdownOverflow(dropdown);
    updateParentDropdownOverflow(dropdown);
  }

  function updateRootDropdown(dropdown) {
    dropdown.style.setProperty('--distance-to-top', dropdown.getBoundingClientRect().top + 'px');
    scheduleSyncDropdownOverflow(dropdown);
  }

  function handleDropdownChange(dropdown) {
    if (dropdown.getAttribute('aria-hidden') !== 'false') {
      if (isNestedFlyout(dropdown)) {
        var parentMenu = getAnchorMenu(dropdown);
        clearNestedPin(dropdown);
        if (parentMenu) {
          if (isRootDropdown(parentMenu)) {
            scheduleSyncDropdownOverflow(parentMenu);
          } else if (isNestedFlyout(parentMenu)) {
            scheduleSyncDropdownOverflow(parentMenu);
          }
        }
      }
      return;
    }

    if (isNestedFlyout(dropdown)) {
      pinNestedDropdown(dropdown);
      return;
    }

    if (isRootDropdown(dropdown)) {
      updateRootDropdown(dropdown);
    }
  }

  function updateOnResize() {
    navBar.querySelectorAll('.nav-dropdown[aria-hidden="false"]').forEach(function (dropdown) {
      if (isRootDropdown(dropdown)) {
        updateRootDropdown(dropdown);
      } else if (isNestedFlyout(dropdown)) {
        pinNestedDropdown(dropdown);
      }
    });
  }

  var dropdownMenuObserver = new MutationObserver(function (mutationList) {
    mutationList.forEach(function (mutation) {
      if (mutation.attributeName !== 'aria-hidden') {
        return;
      }
      handleDropdownChange(mutation.target);
    });
  });

  navBar.querySelectorAll('.nav-dropdown').forEach(function (dropdown) {
    dropdownMenuObserver.observe(dropdown, { attributes: true, attributeFilter: ['aria-hidden'] });
  });

  window.addEventListener('resize', updateOnResize);
})();

/* ===============================================
#共通関数: スクロールバー機能
=============================================== */
/**
 * 画像読み込み・フォント適用後に Splide のスライド幅を再計算する（Safari 初回表示のレイアウト崩れ対策）
 * @param {Object} splide - Splideインスタンス
 * @param {HTMLElement} sliderElement - スライダー要素
 */
function initSplideLayoutRefresh(splide, sliderElement) {
  if (!splide || !sliderElement) {
    return;
  }

  let refreshScheduled = false;

  function scheduleRefresh() {
    if (refreshScheduled) {
      return;
    }
    refreshScheduled = true;
    requestAnimationFrame(function () {
      refreshScheduled = false;
      if (typeof splide.refresh === 'function') {
        splide.refresh();
      }
    });
  }

  window.addEventListener('load', scheduleRefresh, { once: true });

  sliderElement.querySelectorAll('img').forEach(function (img) {
    if (img.complete) {
      return;
    }
    img.addEventListener('load', scheduleRefresh, { once: true });
    img.addEventListener('error', scheduleRefresh, { once: true });
  });

  scheduleRefresh();
}

/**
 * Splideスライダーにスクロールバー機能を追加する共通関数
 * @param {Object} splide - Splideインスタンス
 * @param {HTMLElement} containerElement - スクロールバーを検索する親要素（スライダーのコンテナ）
 */
function initSplideScrollbar(splide, containerElement) {
  const scrollbar = containerElement.querySelector(".custom-splide__scrollbar");
  const handle = containerElement.querySelector(".custom-splide__scrollbar__handle");

  if (!scrollbar || !handle) {
    return;
  }

  // 各スライダーごとに独立したドラッグ状態を管理
  const dragState = {
    isDragging: false,
    startX: 0,
    startLeft: 0
  };

  // スクロールバーの幅と位置を更新
  function updateScrollbar() {
    const totalSlides = splide.length;
    const visibleSlides = splide.options.perPage;

    // スライダーがループモードの場合は特別な処理が必要
    if (splide.options.type === 'loop') {
      const handleWidth = (visibleSlides / totalSlides) * 100;
      handle.style.width = `${handleWidth}%`;
      // ループモードでは位置計算が異なる
      const currentIndex = splide.index;
      const normalizedIndex = currentIndex % totalSlides;
      // 最後のスライドまで到達できるように、totalSlides - 1で割る
      const end = totalSlides - visibleSlides;
      const maxScrollableDistance = 100 - handleWidth;
      if (end > 0) {
        const rate = normalizedIndex / end;
        handle.style.left = `${Math.min(rate * maxScrollableDistance, maxScrollableDistance)}%`;
      } else {
        handle.style.left = "0%";
      }
      return;
    }

    const end = totalSlides - visibleSlides;
    if (end <= 0) {
      handle.style.width = "100%";
      handle.style.left = "0%";
      return;
    }

    const handleWidth = (visibleSlides / totalSlides) * 100;
    const rate = splide.index / end;
    const maxScrollableDistance = 100 - handleWidth;

    handle.style.width = `${handleWidth}%`;
    handle.style.left = `${Math.min(rate * maxScrollableDistance, maxScrollableDistance)}%`;
  }

  // ドラッグ開始
  handle.addEventListener("mousedown", (event) => {
    event.preventDefault();
    dragState.isDragging = true;
    dragState.startX = event.clientX;
    dragState.startLeft = parseFloat(handle.style.left || "0");
    document.body.style.userSelect = "none"; // テキスト選択を防ぐ
  });

  // ドラッグ中（このスライダー専用のハンドラー）
  const handleMouseMove = (event) => {
    if (!dragState.isDragging) return;

    const scrollbarWidth = scrollbar.offsetWidth;
    const handleWidth = handle.offsetWidth;
    const deltaX = event.clientX - dragState.startX;
    const handleWidthPercent = (handleWidth / scrollbarWidth) * 100;
    const maxScrollableDistance = 100 - handleWidthPercent;
    let newLeft = dragState.startLeft + (deltaX / scrollbarWidth) * 100;
    newLeft = Math.max(0, Math.min(newLeft, maxScrollableDistance));
    handle.style.left = `${newLeft}%`;

    // スライダーの位置を更新
    const totalSlides = splide.length;
    const visibleSlides = splide.options.perPage;

    if (splide.options.type === 'loop') {
      // ループモードの場合
      const end = totalSlides - visibleSlides;
      if (end > 0 && maxScrollableDistance > 0) {
        const rate = newLeft / maxScrollableDistance;
        const newIndex = Math.round(rate * end) % totalSlides;
        splide.go(newIndex);
      }
    } else {
      const end = totalSlides - visibleSlides;
      if (end > 0 && maxScrollableDistance > 0) {
        const rate = newLeft / maxScrollableDistance;
        const newIndex = Math.round(rate * end);
        splide.go(Math.min(newIndex, end));
      }
    }
  };

  // ドラッグ終了（このスライダー専用のハンドラー）
  const handleMouseUp = () => {
    if (dragState.isDragging) {
      dragState.isDragging = false;
      document.body.style.userSelect = ""; // テキスト選択を復元
      // ドラッグ終了時の停止位置を再計算
      updateScrollbar();
    }
  };

  // イベントリスナーを追加
  document.addEventListener("mousemove", handleMouseMove);
  document.addEventListener("mouseup", handleMouseUp);

  // クリーンアップ関数（必要に応じて使用可能）
  splide.on("destroy", () => {
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  });

  // 初期化時と移動時にスクロールバーを更新
  splide.on("mounted move resize", updateScrollbar);

  // updateScrollbar関数を返して、外部から呼び出せるようにする
  return updateScrollbar;
}

// グローバルスコープに公開（type="module"で読み込まれるため）
window.initSplideScrollbar = initSplideScrollbar;
/**
 * Splideスライダーにホイールスクロール機能を追加する共通関数
 * @param {Object} splide - Splideインスタンス
 * @param {HTMLElement} sliderElement - スライダー要素（オプション、指定がない場合はsplide.rootから取得）
 * @param {Object} options - オプション設定
 * @param {number} options.throttleTime - スクロール処理のスロットル時間（ミリ秒）、デフォルト: 600
 * @param {number} options.scrollThreshold - スクロール量の閾値（この値以上累積されたらスライドを動かす）、デフォルト: 100
 */
function initSplideWheelScroll(splide, sliderElement, options = {}) {
  const element = sliderElement || splide.root;
  if (!element) {
    return;
  }

  const throttleTime = options.throttleTime || 600;
  const scrollThreshold = options.scrollThreshold || 150;
  let isScrolling = false;
  let accumulatedScroll = 0;
  let resetTimer = null;

  const wheelHandler = (e) => {
    // 既にスクロール処理中の場合は無視
    if (isScrolling) {
      e.preventDefault();
      return;
    }

    const deltaX = e.deltaX;
    const deltaY = e.deltaY;

    // X軸の動きがY軸の動きよりも大きい場合のみ処理（横スクロールのみ）
    // タッチパッドでの縦スクロールを除外するため
    if (Math.abs(deltaX) <= Math.abs(deltaY)) {
      return;
    }

    // 横スクロールがない場合は処理しない
    if (deltaX === 0) {
      return;
    }

    // 横スクロールを検出した時点で、ブラウザの戻る/進むを防ぐ
    e.preventDefault();
    e.stopPropagation();

    // スクロール量を累積
    accumulatedScroll += Math.abs(deltaX);

    // 閾値に達したらスライドを動かす
    if (accumulatedScroll >= scrollThreshold) {
      // すぐにスクロール処理中フラグを立てる（複数回のスライドを防ぐ）
      isScrolling = true;

      if (deltaX > 0) {
        splide.go('>');
      } else if (deltaX < 0) {
        splide.go('<');
      }

      // 累積値をリセット
      accumulatedScroll = 0;
      if (resetTimer) {
        clearTimeout(resetTimer);
        resetTimer = null;
      }

      // スロットル時間後にフラグをリセット
      setTimeout(() => {
        isScrolling = false;
      }, throttleTime);
    } else {
      // 閾値に達していない場合は、一定時間後に累積値をリセット
      if (resetTimer) {
        clearTimeout(resetTimer);
      }
      resetTimer = setTimeout(() => {
        accumulatedScroll = 0;
        resetTimer = null;
      }, 200);
    }
  };

  element.addEventListener('wheel', wheelHandler, { passive: false });

  // クリーンアップ関数
  splide.on("destroy", () => {
    element.removeEventListener('wheel', wheelHandler);
    if (resetTimer) {
      clearTimeout(resetTimer);
      resetTimer = null;
    }
  });
}

/* ===============================================
#Section Slide
=============================================== */
/* 2025/12/12 - Section Slide実装（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const sliderElement = document.querySelector('.custom-section-slide__slider');
  if (!sliderElement) {
    return;
  }

  const splide = new Splide('.custom-section-slide__slider', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: 24,
    padding: { right: '36.7%' },
    autoplay: true,
    pagination: false,
    rewind: true,
    interval: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnScroll: false,
    pauseOnMouseEnter: false,
    pauseOnMouseLeave: false,
    pauseOnTouch: false,
    pauseOnTouchMove: false,
    pauseOnTouchEnd: false,
    pauseOnTouchStart: false,
    breakpoints: {
      1023: {
        padding: "15%",
        gap: 12,
      },
    },
  }).mount();

  // スクロール機能実装
  initSplideWheelScroll(splide, sliderElement);

  // スクロールバー機能を初期化
  initSplideScrollbar(splide, sliderElement.closest('section') || document);

  // 次のスライドが表示されるタイミングで発生
  splide.on('active', function () {
    slideIndex();
  });

  function slideIndex() {
    // 現在のスライドが何枚目かを取得
    document.getElementById('slide-current').textContent = splide.index + 1;
    // スライドの総数を取得
    document.getElementById('slide-length').textContent = splide.length;
  }
  slideIndex();
  autoplayToggle();
  function autoplayToggle() {
    const toggle = splide.root.querySelector('.custom-section-slide__slider-autoplay-toggle');
    const autoplay = splide.Components.Autoplay;
    const labelPlay = toggle.getAttribute('data-label-play');
    const labelPause = toggle.getAttribute('data-label-pause');

    // aria-labelを更新する関数
    function updateAriaLabel(isPlaying) {
      toggle.setAttribute('aria-label', isPlaying ? labelPause : labelPlay);
    }

    // Autoplayの状態変更イベントをリッスン
    splide.on('autoplay:play', function () {
      toggle.classList.remove('pause');
      toggle.classList.add('play');
      updateAriaLabel(true);
    });

    splide.on('autoplay:pause', function () {
      toggle.classList.remove('play');
      toggle.classList.add('pause');
      updateAriaLabel(false);
    });

    // 初期状態のaria-labelを設定
    if (toggle.classList.contains('play')) {
      updateAriaLabel(true);
    } else {
      updateAriaLabel(false);
    }

    // ボタンクリック時の処理
    toggle.addEventListener('click', function () {
      if (toggle.classList.contains('play')) {
        autoplay.pause();
      } else {
        autoplay.play();
      }
    });
  }
});
/* ===============================================
#vw単位の設定
=============================================== */
const setVw = function () {
  const vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

/* ===============================================
#Section Best Sellers
=============================================== */
/* 2025/12/13 - Section Best Sellers実装（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const sectionElement = document.querySelector('.custom-section-best-sellers');
  if (!sectionElement) {
    return;
  }

  const tagButtons = sectionElement.querySelectorAll('.custom-section-best-sellers__tag');
  const productContainers = sectionElement.querySelectorAll('.custom-section-best-sellers__product');
  const splideInstances = new Map(); // 各スライダーのインスタンスを保存

  // Splide設定オプション（共通設定）
  const splideOptions = {
    perPage: 4,
    perMove: 1,
    gap: 12,
    padding: { right: "15%" },
    pagination: false,
    breakpoints: {
      1023: {
        perPage: 2,
      },
      767: {
        perPage: 1,
        padding: "16%",
        gap: 16
      },
    },
  };

  // 各スライダーに対して初期化処理を実行
  productContainers.forEach(function (productContainer) {
    const sliderElement = productContainer.querySelector('.custom-section-best-sellers__product-list');
    if (!sliderElement) {
      return;
    }

    const collectionId = productContainer.getAttribute('data-collection-id');
    const isActive = productContainer.classList.contains('is-active');

    const splide = new Splide(sliderElement, splideOptions);

    // アクティブなスライダーのみマウント
    let updateScrollbar = null;
    if (isActive) {
      splide.mount();
      initSplideLayoutRefresh(splide, sliderElement);
      // スクロールバー機能を初期化
      updateScrollbar = initSplideScrollbar(splide, sliderElement);
      // スクロール機能実装
      initSplideWheelScroll(splide, sliderElement);
    }

    // インスタンスを保存
    splideInstances.set(collectionId, {
      splide: splide,
      container: productContainer,
      sliderElement: sliderElement,
      updateScrollbar: updateScrollbar
    });
  });

  // タグ切り替え機能（共通関数）
  function switchCollection(clickedCollectionId, clickedButton) {
    // すべてのタグからis-activeクラスを削除し、タブ状態をリセット
    tagButtons.forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('tabindex', '-1');
    });

    // クリックされたタグにis-activeクラスを追加
    let activeButton = null;
    if (clickedButton && clickedButton.classList.contains('custom-section-best-sellers__tag')) {
      clickedButton.classList.add('is-active');
      clickedButton.setAttribute('aria-selected', 'true');
      clickedButton.setAttribute('tabindex', '0');
      activeButton = clickedButton;
    } else {
      // value-pickerから選択された場合、対応するデスクトップ用タグにもis-activeを追加
      const correspondingTag = sectionElement.querySelector(
        `.custom-section-best-sellers__tag[data-collection-id="${clickedCollectionId}"]`
      );
      if (correspondingTag) {
        correspondingTag.classList.add('is-active');
        correspondingTag.setAttribute('aria-selected', 'true');
        correspondingTag.setAttribute('tabindex', '0');
        activeButton = correspondingTag;
      }
    }

    // ボタンのhrefを更新
    const seeMoreButton = sectionElement.querySelector('.custom-section-best-sellers__head .custom-button');
    if (seeMoreButton && activeButton) {
      const collectionUrl = activeButton.getAttribute('data-collection-url');
      if (collectionUrl) {
        seeMoreButton.setAttribute('href', collectionUrl);
      }
    } else {
      // value-pickerから選択された場合のフォールバック
      const valuePickerItem = sectionElement.querySelector(
        `.value-picker__choice-item[data-collection-id="${clickedCollectionId}"]`
      );
      if (valuePickerItem && seeMoreButton) {
        const collectionUrl = valuePickerItem.getAttribute('data-collection-url');
        if (collectionUrl) {
          seeMoreButton.setAttribute('href', collectionUrl);
        }
      }
    }

    // value-pickerの選択状態を更新
    const valuePickerItems = sectionElement.querySelectorAll('.value-picker__choice-item');
    valuePickerItems.forEach(function (item) {
      item.classList.remove('is-selected');
    });

    const selectedItem = sectionElement.querySelector(
      `.value-picker__choice-item[data-collection-id="${clickedCollectionId}"]`
    );
    if (selectedItem) {
      selectedItem.classList.add('is-selected');
      // ボタンのテキストを更新（チェックマークアイコンを除外）
      const valuePickerButton = sectionElement.querySelector('.custom-section-best-sellers__value-picker-button');
      if (valuePickerButton) {
        const buttonText = valuePickerButton.querySelector('span');
        if (buttonText && selectedItem) {
          // チェックマークアイコンを除外してテキストを取得
          const itemText = selectedItem.cloneNode(true);
          const checkIcon = itemText.querySelector('svg');
          if (checkIcon) {
            checkIcon.remove();
          }
          buttonText.textContent = itemText.textContent.trim();
        }
      }
    }

    // すべての商品コンテナからis-activeクラスを削除し、非表示にする
    productContainers.forEach(function (container) {
      container.classList.remove('is-active');
      container.setAttribute('aria-hidden', 'true');
      const instance = splideInstances.get(container.getAttribute('data-collection-id'));
      if (instance && instance.splide) {
        // スライダーを破棄
        instance.splide.destroy();
      }
    });

    // クリックされたタグに対応する商品コンテナを表示
    const targetContainer = sectionElement.querySelector(
      `.custom-section-best-sellers__product[data-collection-id="${clickedCollectionId}"]`
    );

    if (targetContainer) {
      targetContainer.classList.add('is-active');
      targetContainer.setAttribute('aria-hidden', 'false');
      const instance = splideInstances.get(clickedCollectionId);
      if (instance) {
        // スライダーを再初期化
        const newSplide = new Splide(instance.sliderElement, splideOptions);
        newSplide.mount();
        initSplideLayoutRefresh(newSplide, instance.sliderElement);
        // スクロールバー機能を初期化
        const updateScrollbar = initSplideScrollbar(newSplide, instance.sliderElement);
        // スクロール機能実装
        initSplideWheelScroll(newSplide, instance.sliderElement);
        // インスタンスを更新
        splideInstances.set(clickedCollectionId, {
          splide: newSplide,
          container: targetContainer,
          sliderElement: instance.sliderElement,
          updateScrollbar: updateScrollbar
        });
        // スクロールバーを明示的に更新（マウント後の確実な更新のため）
        if (updateScrollbar) {
          // 少し遅延を入れて、DOMが完全に更新された後にスクロールバーを更新
          setTimeout(function () {
            updateScrollbar();
          }, 0);
        }
      }
    }
  }

  // デスクトップ用タグボタンのクリックイベント
  tagButtons.forEach(function (tagButton) {
    tagButton.addEventListener('click', function () {
      const clickedCollectionId = tagButton.getAttribute('data-collection-id');
      switchCollection(clickedCollectionId, tagButton);
      tagButton.focus();
    });

    // キーボード操作（左右矢印キー）でタブ移動
    tagButton.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
        return;
      }

      event.preventDefault();

      const currentIndex = Array.prototype.indexOf.call(tagButtons, tagButton);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tagButtons.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tagButtons.length) % tagButtons.length;
      }

      const nextButton = tagButtons[nextIndex];
      if (nextButton) {
        const nextCollectionId = nextButton.getAttribute('data-collection-id');
        switchCollection(nextCollectionId, nextButton);
        nextButton.focus();
      }
    });
  });

  // ValuePickerの初期化（theme.jsが読み込まれた後に実行）
  function initValuePicker() {
    if (typeof ValuePicker !== 'undefined') {
      const bestSellersValuePicker = new ValuePicker('best-sellers-selector', {
        onValueSelect: function (collectionId) {
          const selectedItem = sectionElement.querySelector(
            `.value-picker__choice-item[data-value="${collectionId}"]`
          );
          if (selectedItem) {
            switchCollection(collectionId, selectedItem);
          }
        }
      });
    } else {
      // ValuePickerがまだ読み込まれていない場合は少し待って再試行
      setTimeout(initValuePicker, 100);
    }
  }

  initValuePicker();
});

/* ===============================================
#Section Pickup
=============================================== */
/* 2025/12/14 - Section Pickup実装（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const sectionElement = document.querySelector('.custom-section-pickup__slider');
  if (!sectionElement) {
    return;
  }

  const splide = new Splide(sectionElement, {
    type: 'loop',
    perPage: 2,
    perMove: 1,
    gap: 24,
    pagination: false,
    padding: "21%",
    breakpoints: {
      1023: {
        padding: "15%",
        perPage: 1,
      },
    },
  }).mount();

  // スクロール機能実装
  initSplideWheelScroll(splide, sectionElement);
});

/* ===============================================
#Section Promotions
=============================================== */
/* 2025/12/14 - Section Promotions実装（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const sliderElements = document.querySelectorAll('.custom-section-promotions__slider');
  if (!sliderElements.length) {
    return;
  }

  const splideOptions = {
    perPage: 4,
    perMove: 1,
    gap: 16,
    padding: { right: '5%' },
    breakpoints: {
      1023: {
        perPage: 3,
      },
      767: {
        perPage: 1,
        padding: { right: '22%' },
      },
    },
  };

  sliderElements.forEach(function (sectionElement) {
    if (sectionElement.classList.contains('splide-initialized')) {
      return;
    }
    const splide = new Splide(sectionElement, splideOptions).mount();
    initSplideWheelScroll(splide, sectionElement);
    sectionElement.classList.add('splide-initialized');
  });
});

/* ===============================================
#Section Link List
=============================================== */
/* 2025/12/14 - Section Link List実装（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {

  const sectionElement = document.querySelector('.custom-section-link-list__slider');
  if (!sectionElement) {
    return;
  }

  let splideInstance = null;

  // スライダーの初期化関数
  function initSplide() {
    if (window.innerWidth >= 768 && !splideInstance) {
      splideInstance = new Splide(sectionElement, {
        perPage: 8,
        perMove: 1,
        gap: 24,
        padding: '80px',
        pagination: false,
        breakpoints: {
          2300: {
            perPage: 7,
            padding: '70px',
          },

          1920: {
            perPage: 5,
            padding: '60px',
          },

          1440: {
            perPage: 3,
          },

          1023: {
            perPage: 2,
          },
        },
      }).mount();
      // スクロール機能実装
      initSplideWheelScroll(splideInstance, sectionElement);
    } else if (window.innerWidth < 768 && splideInstance) {
      splideInstance.destroy();
      splideInstance = null;
    }
  }

  // 初期化
  initSplide();

  // リサイズ時の処理
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initSplide();
    }, 100);
  });
});

/* ===============================================
#商品ページ 在庫・配送情報の数量選択とAdd to Cart連携
=============================================== */
/* 2025/12/XX - 在庫・配送情報の数量選択とAdd to Cartボタン（by AI） */
document.addEventListener('DOMContentLoaded', function () {
  // Form.serializeをラップして、実行直前に数量を同期
  // Formクラスがグローバルに公開されているか確認
  let FormClass = null;
  if (typeof window.Form !== 'undefined') {
    FormClass = window.Form;
  } else if (typeof Form !== 'undefined') {
    FormClass = Form;
  }

  if (FormClass && FormClass.serialize) {
    const originalSerialize = FormClass.serialize;
    FormClass.serialize = function (form) {
      // フォーム送信前に数量を確実に同期
      if (form && form.action && form.action.includes('/cart/add')) {
        const formId = form.id;
        if (formId) {
          // product-availability-info内の数量入力を取得
          const availabilityInfo = document.querySelector(`.product-availability-info`);
          if (availabilityInfo) {
            const availabilityInput = availabilityInfo.querySelector('input[name="quantity"]');
            const quantityInputs = form.querySelectorAll('input[name="quantity"]');
            if (availabilityInput && quantityInputs.length > 0) {
              const quantity = themeNormalizeAvailabilityQuantityInput(availabilityInput);
              // 全ての数量入力を更新
              quantityInputs.forEach(function (input) {
                input.value = quantity;
                input.setAttribute('value', quantity);
              });
              // form.elementsからも確実に取得できるように
              if (form.elements && form.elements.namedItem('quantity')) {
                form.elements.namedItem('quantity').value = quantity;
              }
              // form.elements配列を直接更新（Form.serializeが使用する）
              for (let i = 0; i < form.elements.length; i++) {
                if (form.elements[i].name === 'quantity') {
                  form.elements[i].value = quantity;
                }
              }
            }
          }
        }
      }
      return originalSerialize.call(this, form);
    };
  }

  // 数量選択の同期（quantity-pickerの標準動作を利用）
  const availabilityInfo = document.querySelector('.product-availability-info');
  const quantitySyncMap = new Map(); // フォームIDと数量入力のマッピングを保存

  if (availabilityInfo) {
    const availabilityInput = availabilityInfo.querySelector('input[name="quantity"]');
    if (availabilityInput) {
      // フォームIDを取得
      const mainForm = document.querySelector('form[action*="/cart/add"]');
      if (!mainForm || !mainForm.id) return;
      const formId = mainForm.id;

      const mainQuantityInput = mainForm.querySelector('input[name="quantity"]');
      if (!mainQuantityInput) return;

      // マッピングを保存
      quantitySyncMap.set(formId, {
        availabilityInput: availabilityInput,
        mainQuantityInput: mainQuantityInput
      });

      function syncQuantityToMain() {
        const quantity = themeNormalizeAvailabilityQuantityInput(availabilityInput);
        mainQuantityInput.value = quantity;
        mainQuantityInput.setAttribute('value', String(quantity));
        if (mainForm.elements && mainForm.elements.namedItem('quantity')) {
          mainForm.elements.namedItem('quantity').value = quantity;
        }
      }

      availabilityInput.addEventListener('input', function () {
        themeHideProductCartNotice();
        const raw = String(availabilityInput.value).trim();
        if (raw === '' || raw === '-') {
          availabilityInput.value = '';
          mainQuantityInput.value = 0;
          mainQuantityInput.setAttribute('value', '0');
          return;
        }
        syncQuantityToMain();
      });

      availabilityInput.addEventListener('change', function () {
        themeHideProductCartNotice();
        syncQuantityToMain();
        mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      });

      availabilityInput.addEventListener('blur', function () {
        syncQuantityToMain();
      });

      const quantityPicker = availabilityInput.closest('quantity-picker');
      if (quantityPicker) {
        quantityPicker.addEventListener('click', function (e) {
          if (e.target.closest('[data-action="decrease-picker-quantity"], [data-action="increase-picker-quantity"]')) {
            themeHideProductCartNotice();
            setTimeout(syncQuantityToMain, 0);
          }
        });
      }

      const variantJsonEl = document.querySelector('variant-picker script[data-variant]');
      if (variantJsonEl) {
        try {
          const initialVariant = JSON.parse(variantJsonEl.textContent || '{}');
          themeUpdateAvailabilityInventoryData(initialVariant);
          themeApplyAvailabilityVariantQuantityLimits(initialVariant, availabilityInfo);
        } catch (err) {
          /* ignore */
        }
      } else if (availabilityInfo && availabilityInfo.dataset.inventoryManagement === 'shopify') {
        const availabilityForm = themeGetAvailabilityForm(availabilityInfo);
        const variantId = themeGetAvailabilityVariantIdFromForm(availabilityForm);
        if (variantId) {
          themeUpdateAvailabilityInventoryData({
            id: variantId,
            inventory_management: availabilityInfo.dataset.inventoryManagement,
            inventory_policy: availabilityInfo.dataset.inventoryPolicy,
            inventory_quantity: parseInt(availabilityInfo.dataset.inventoryQuantity, 10) || 0
          });
        }
      }

      // メインフォームの数量入力から在庫情報の数量入力へ同期
      mainQuantityInput.addEventListener('change', function () {
        availabilityInput.value = this.value;
        availabilityInput.setAttribute('value', this.value);
        availabilityInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  // buy-buttonのクリックイベントをインターセプトして数量を同期（capture phaseで実行）
  document.addEventListener('click', function (e) {
    // buy-button要素またはその中のボタンがクリックされた場合
    let buyButton = e.target.closest('buy-button');
    let form = null;

    if (buyButton) {
      form = buyButton.closest('form[action*="/cart/add"]');
    } else {
      // buy-button内のボタンがクリックされた場合もチェック
      const clickedButton = e.target.closest('button[type="submit"]');
      if (clickedButton) {
        buyButton = clickedButton.closest('buy-button');
        if (buyButton) {
          form = buyButton.closest('form[action*="/cart/add"]');
        }
      }
    }

    if (!form) return;

    const formId = form.id;
    if (!formId) return;

    // product-availability-info内の数量入力を取得
    const availabilityInfo = document.querySelector('.product-availability-info');
    if (availabilityInfo) {
      const availabilityInput = availabilityInfo.querySelector('input[name="quantity"]');
      if (availabilityInput) {
        const quantity = themeNormalizeAvailabilityQuantityInput(availabilityInput);
        const quantityInputs = form.querySelectorAll('input[name="quantity"]');
        // 全ての数量入力を更新
        quantityInputs.forEach(function (input) {
          input.value = quantity;
          input.setAttribute('value', quantity);
        });
        // form.elementsからも確実に取得できるように
        if (form.elements && form.elements.namedItem('quantity')) {
          form.elements.namedItem('quantity').value = quantity;
        }
        // form.elements配列を直接更新（Form.serializeが使用する）
        for (let i = 0; i < form.elements.length; i++) {
          if (form.elements[i].name === 'quantity') {
            form.elements[i].value = quantity;
          }
        }
      }
    }
  }, true); // capture phaseで実行（buy-buttonのイベントハンドラーより先に実行）

  // フォーム送信時にも数量を確実に同期（フォールバック）
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.tagName !== 'FORM' || !form.action || !form.action.includes('/cart/add')) {
      return;
    }

    const formId = form.id;
    if (!formId) return;

    const syncData = quantitySyncMap.get(formId);
    if (syncData && syncData.availabilityInput) {
      const quantity = themeNormalizeAvailabilityQuantityInput(syncData.availabilityInput);
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = quantity;
        quantityInput.setAttribute('value', quantity);
      }
    }
  }, true); // capture phaseで実行

  document.addEventListener('variant:change', function (e) {
    const availabilityInfo = document.querySelector('.product-availability-info');
    if (!availabilityInfo || !e.detail || !e.detail.variant) return;
    themeHideProductCartNotice();
    themeUpdateAvailabilityInventoryData(e.detail.variant);
    themeApplyAvailabilityVariantQuantityLimits(e.detail.variant, availabilityInfo);
  });

  /* 商品ページの数量ピッカーは quantity-picker + input の min/max（数量制限）。在庫超過は Add to Cart 時に部分追加 */
});

/* ===============================================
#商品ページ タブ切り替え機能
=============================================== */
/* 2025/12/XX - 商品説明タブ切り替え（by AI） */
document.addEventListener('DOMContentLoaded', function () {
  const tabContainers = document.querySelectorAll('.product-description-tabs');

  tabContainers.forEach(function (container) {
    const tabs = container.querySelectorAll('.product-description-tabs__tab');
    const panels = container.querySelectorAll('.product-description-tabs__panel');

    if (!tabs.length || !panels.length) return;

    // 初期 ARIA セットアップ
    tabs.forEach(function (tab, index) {
      const tabId = tab.id || `product-description-tab-${index}`;
      tab.id = tabId;
      tab.setAttribute('role', 'tab');

      const target = tab.getAttribute('data-tab');
      const panel = target
        ? container.querySelector(`.product-description-tabs__panel[data-panel="${target}"]`)
        : null;
      if (panel) {
        const panelId = panel.id || `product-description-panel-${index}`;
        panel.id = panelId;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
      }
    });

    // タブ切り替え関数
    function switchTab(targetTab) {
      tabs.forEach(function (t) {
        const isTarget = t.getAttribute('data-tab') === targetTab;
        t.classList.toggle('product-description-tabs__tab--active', isTarget);
        t.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        t.setAttribute('tabindex', isTarget ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        const isTarget = panel.getAttribute('data-panel') === targetTab;
        panel.classList.toggle('product-description-tabs__panel--active', isTarget);
        panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const targetTab = this.getAttribute('data-tab');
        switchTab(targetTab);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();

        const currentIndex = Array.prototype.indexOf.call(tabs, tab);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        }

        const nextTab = tabs[nextIndex];
        if (nextTab) {
          const targetTab = nextTab.getAttribute('data-tab');
          switchTab(targetTab);
          nextTab.focus();
        }
      });
    });

    // SP表示用のモーダル機能
    const mobileHeader = container.querySelector('[data-mobile-tab-trigger]');
    const mobileModal = container.querySelector('[data-mobile-tab-modal]');
    const mobileOptions = container.querySelectorAll('[data-mobile-tab-option]');
    const mobileClose = container.querySelector('[data-mobile-tab-close]');

    if (mobileHeader && mobileModal) {
      // ヘッダーテキストを更新する関数
      function updateHeaderText(targetTab) {
        const headerText = mobileHeader.querySelector('.product-description-tabs__mobile-header-text');
        if (headerText) {
          let text = 'Product Details : ';
          if (targetTab === 'description') {
            text += 'Description';
          } else if (targetTab === 'details') {
            text += 'Details';
          } else if (targetTab === 'store-stock') {
            text += 'Store Stock Status';
          }
          headerText.textContent = text;
        }
      }

      // アクティブオプションを更新する関数
      function updateActiveOption(targetTab) {
        mobileOptions.forEach(function (opt) {
          const optValue = opt.getAttribute('data-mobile-tab-option');
          if (optValue === targetTab) {
            opt.setAttribute('data-active', 'true');
          } else {
            opt.setAttribute('data-active', 'false');
          }
        });
      }

      // モーダルを開く
      mobileHeader.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        mobileModal.setAttribute('aria-hidden', 'false');
        mobileHeader.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });

      // モーダルを閉じる
      function closeModal() {
        mobileModal.setAttribute('aria-hidden', 'true');
        mobileHeader.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }

      if (mobileClose) {
        mobileClose.addEventListener('click', closeModal);
      }

      // オプション選択時の処理
      mobileOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          const targetTab = this.getAttribute('data-mobile-tab-option');

          // タブを切り替え
          switchTab(targetTab);

          // モーダル内のオプションのアクティブ状態を更新
          updateActiveOption(targetTab);

          // ヘッダーテキストを更新
          updateHeaderText(targetTab);

          // モーダルを閉じる
          closeModal();
        });
      });

      // 初期状態のアクティブオプションを設定
      const activeTab = container.querySelector('.product-description-tabs__tab--active');
      if (activeTab) {
        const activeTabValue = activeTab.getAttribute('data-tab');
        updateActiveOption(activeTabValue);
        updateHeaderText(activeTabValue);
      }

      // タブが変更されたときにアクティブオプションとヘッダーテキストを更新
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const targetTab = this.getAttribute('data-tab');
          updateActiveOption(targetTab);
          updateHeaderText(targetTab);
        });
      });
    }
  });
});

/* ===============================================
#商品説明 Read More 機能
=============================================== */
(function () {
  'use strict';

  function initExpandableDescription() {
    const expandables = document.querySelectorAll('[data-expandable-description]');

    expandables.forEach(function (expandable) {
      // 既に初期化済みの場合はスキップ
      if (expandable.hasAttribute('data-initialized')) return;

      const content = expandable.querySelector('[data-expandable-content]');
      const readmore = expandable.querySelector('[data-expandable-readmore]');

      if (!content) return;

      // 行数をチェック（20行以上かどうか）
      const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight) || 24;
      const contentHeight = content.scrollHeight;
      const lines = Math.ceil(contentHeight / lineHeight);

      if (lines > 20) {
        // 20行以上の場合、折りたたみ状態にする
        expandable.setAttribute('data-collapsed', 'true');

        if (readmore) {
          readmore.addEventListener('click', function () {
            expandable.setAttribute('data-collapsed', 'false');
          });
        }
      } else {
        // 20行以下の場合
        expandable.setAttribute('data-collapsed', 'false');
      }

      expandable.setAttribute('data-initialized', 'true');
    });
  }

  // DOMContentLoadedで初期化
  document.addEventListener('DOMContentLoaded', initExpandableDescription);

  // タブ切り替え時にも再計算（タブが非表示の場合、高さが計算できないため）
  document.addEventListener('click', function (event) {
    const tabButton = event.target.closest('[data-tab]');
    if (tabButton && tabButton.getAttribute('data-tab') === 'description') {
      setTimeout(initExpandableDescription, 100);
    }
  });
})();

/* ===============================================
#商品説明 Iframe許容機能
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('[data-rich-embed-fix]');

  containers.forEach(function (container) {
    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];

    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (
        node.nodeValue &&
        (
          node.nodeValue.includes('<iframe') ||
          node.nodeValue.includes('&lt;iframe')
        )
      ) {
        textNodes.push(node);
      }
    }

    textNodes.forEach(function (node) {
      let text = node.nodeValue.trim();

      text = text
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, '&');

      const srcMatch = text.match(/src=["']([^"']+)["']/i);

      if (!srcMatch || !srcMatch[1]) return;

      const src = srcMatch[1];

      let embedElement;

      if (src.match(/\.(mp4|webm|ogg)(\?.*)?$/i)) {
        embedElement = document.createElement('video');
        embedElement.controls = true;
        embedElement.playsInline = true;
        embedElement.preload = 'metadata';
        embedElement.style.width = '100%';
        embedElement.style.maxWidth = '100%';

        const source = document.createElement('source');
        source.src = src;

        if (src.match(/\.mp4(\?.*)?$/i)) {
          source.type = 'video/mp4';
        } else if (src.match(/\.webm(\?.*)?$/i)) {
          source.type = 'video/webm';
        } else if (src.match(/\.ogg(\?.*)?$/i)) {
          source.type = 'video/ogg';
        }

        embedElement.appendChild(source);
      } else {
        embedElement = document.createElement('iframe');
        embedElement.src = src;
        embedElement.width = '100%';
        embedElement.height = '420';
        embedElement.loading = 'lazy';
        embedElement.allowFullscreen = true;
        embedElement.setAttribute('frameborder', '0');
        embedElement.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'rich-embed-wrapper';
      wrapper.appendChild(embedElement);

      node.parentNode.replaceWith(wrapper);
    });
  });
});

/* ===============================================
#Recently Viewed Products - Splide Slider
=============================================== */
function initCustomProductSlider(sliderElement) {
  if (!sliderElement || sliderElement.classList.contains('splide-initialized')) {
    return;
  }

  // Best Sellersと同じ設定を使用
  const splideOptions = {
    perPage: 5,
    perMove: 1,
    gap: 16,
    pagination: false,
    padding: {
      right: "8%"
    },
    breakpoints: {
      1300: {
        perPage: 4,
      },
      1023: {
        perPage: 3,
      },
      767: {
        perPage: 1,
        padding: "16%",
        gap: 16
      },
    },
  };

  const splide = new Splide(sliderElement, splideOptions);
  splide.mount();
  initSplideLayoutRefresh(splide, sliderElement);

  // スクロールバー機能を初期化
  initSplideScrollbar(splide, sliderElement);

  // スクロール機能実装
  initSplideWheelScroll(splide, sliderElement);

  // 初期化済みフラグを設定
  sliderElement.classList.add('splide-initialized');
}

function initRecentlyViewedSlider() {
  document.querySelectorAll('.recently-viewed-products-slider').forEach(initCustomProductSlider);
}

function initProductRecommendationsSlider() {
  document.querySelectorAll('.product-recommendations-slider').forEach(initCustomProductSlider);
}

function initCustomProductSliders() {
  initRecentlyViewedSlider();
  initProductRecommendationsSlider();
}

function observeCustomProductSliderSection(sectionElement) {
  if (!sectionElement || sectionElement.hasAttribute('data-custom-product-slider-observed')) {
    return;
  }

  sectionElement.setAttribute('data-custom-product-slider-observed', 'true');

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) {
          return;
        }

        if (node.classList && (
          node.classList.contains('recently-viewed-products-slider') ||
          node.classList.contains('product-recommendations-slider')
        )) {
          initCustomProductSlider(node);
          return;
        }

        if (!node.querySelector) {
          return;
        }

        node.querySelectorAll('.recently-viewed-products-slider, .product-recommendations-slider').forEach(initCustomProductSlider);
      });
    });
  });

  observer.observe(sectionElement, {
    childList: true,
    subtree: true
  });
}

// DOMContentLoaded時に初期化
document.addEventListener('DOMContentLoaded', function () {
  initCustomProductSliders();

  document.querySelectorAll('[data-section-type="recently-viewed-products"], [data-section-type="product-recommendations"]').forEach(observeCustomProductSliderSection);
});

/* ===============================================
#Recently Viewed Products - カート追加機能
=============================================== */
function themeHandleRecentlyViewedCartAdd(button) {
  const variantId = button.getAttribute('data-variant-id');
  if (!variantId || button.disabled) {
    return;
  }

  button.disabled = true;
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  const quantityLimit = themeResolveQuantityLimitForCartAdd(variantId, button);

  themeValidateListingCartAdd(variantId, 1, quantityLimit, false)
    .then(function (validation) {
      if (!validation.ok) {
        themeApplyListingCartAddValidationFailure(validation, quantityLimit, 1);
        return null;
      }

      return fetch(`${window.routes.cartAddUrl}.js`, {
        body: JSON.stringify({
          id: variantId,
          quantity: validation.quantity
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        return { response: response, quantity: validation.quantity };
      });
    })
    .then(function (result) {
      button.disabled = false;
      if (!result || !result.response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        return;
      }

      const response = result.response;
      const quantity = result.quantity;

      if (response.ok) {
        const event = new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            button: button,
            variant: variantId,
            quantity: quantity,
            productAdded: true
          }
        });
        document.documentElement.dispatchEvent(event);

        if (window.theme && window.theme.cartType === 'page') {
          window.location.href = window.routes.cartUrl;
        } else {
          setTimeout(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
            }));
          }, 100);
        }
      } else {
        response.json().then(function (content) {
          alert(window.themeGetSafeCartDescription(content && content.description));
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      }
    })
    .catch(function (error) {
      button.disabled = false;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      console.error('Error adding to cart:', error);
      alert('エラーが発生しました。もう一度お試しください。');
    });
}

function themeAttachRecentlyViewedCartAddListener(button) {
  if (!button || button.hasAttribute('data-listener-attached')) {
    return;
  }
  button.setAttribute('data-listener-attached', 'true');
  button.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    themeHandleRecentlyViewedCartAdd(button);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.recently-viewed-products__buy-button').forEach(themeAttachRecentlyViewedCartAddListener);

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) {
          return;
        }
        const newButtons = node.querySelectorAll
          ? node.querySelectorAll('.recently-viewed-products__buy-button')
          : [];
        newButtons.forEach(themeAttachRecentlyViewedCartAddListener);
      });
    });
  });

  const sectionElement = document.querySelector('[data-section-type="recently-viewed-products"]');
  if (sectionElement) {
    observer.observe(sectionElement, {
      childList: true,
      subtree: true
    });
  }
});

/* ===============================================
#Gift Wrap Checkbox
=============================================== */
/* 2025/12/18 - ギフトラップチェックボックス実装（by Watanabe） */
// document.addEventListener('DOMContentLoaded', function () {
//   const giftWrapCheckbox = document.querySelector('.custom-gift-wrap__checkbox');
//   if (!giftWrapCheckbox) {
//     return;
//   }

//   giftWrapCheckbox.addEventListener('change', function () {
//     const isChecked = this.checked;
//     const variantId = this.getAttribute('data-variant-id');
//     const lineNumber = this.getAttribute('data-line-number');
//     const checkbox = this;

//     // ローディング状態を開始
//     checkbox.disabled = true;
//     document.dispatchEvent(new CustomEvent('theme:loading:start'));

//     if (isChecked) {
//       // カートに追加
//       fetch(`${window.routes.cartAddUrl}.js`, {
//         body: JSON.stringify({
//           id: variantId,
//           quantity: 1
//         }),
//         credentials: 'same-origin',
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         }
//       }).then(function (response) {
//         checkbox.disabled = false;
//         if (response.ok) {
//           // カートを更新してページをリロード
//           if (window.theme && window.theme.pageType === 'cart') {
//             window.location.reload();
//           } else {
//             // カートページ以外の場合はカートをリフレッシュ
//             document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//               bubbles: true
//             }));
//             // カートページにリダイレクト
//             window.location.href = window.routes.cartUrl;
//           }
//         } else {
//           response.json().then(function (content) {
//             alert(content.description || 'ギフトラップの追加に失敗しました。');
//             checkbox.checked = false;
//             document.dispatchEvent(new CustomEvent('theme:loading:end'));
//           });
//         }
//       }).catch(function (error) {
//         checkbox.disabled = false;
//         checkbox.checked = false;
//         alert('エラーが発生しました。もう一度お試しください。');
//         document.dispatchEvent(new CustomEvent('theme:loading:end'));
//       });
//     } else {
//       // カートから削除
//       if (!lineNumber) {
//         checkbox.disabled = false;
//         checkbox.checked = true;
//         alert('ギフトラップの削除に失敗しました。');
//         document.dispatchEvent(new CustomEvent('theme:loading:end'));
//         return;
//       }

//       fetch(`${window.routes.cartChangeUrl}.js`, {
//         body: JSON.stringify({
//           line: lineNumber,
//           quantity: 0
//         }),
//         credentials: 'same-origin',
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         }
//       }).then(function (response) {
//         checkbox.disabled = false;
//         if (response.ok) {
//           // カートを更新してページをリロード
//           if (window.theme && window.theme.pageType === 'cart') {
//             window.location.reload();
//           } else {
//             // カートページ以外の場合はカートをリフレッシュ
//             document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//               bubbles: true
//             }));
//           }
//         } else {
//           response.json().then(function (content) {
//             alert(content.description || 'ギフトラップの削除に失敗しました。');
//             checkbox.checked = true;
//             document.dispatchEvent(new CustomEvent('theme:loading:end'));
//           });
//         }
//       }).catch(function (error) {
//         checkbox.disabled = false;
//         checkbox.checked = true;
//         alert('エラーが発生しました。もう一度お試しください。');
//         document.dispatchEvent(new CustomEvent('theme:loading:end'));
//       });
//     }
//   });
// });

/* ===============================================
#Cart Checkout Validation
=============================================== */
/* 2025/12/18 - カートチェックアウト検証実装（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const cartSection = document.querySelector('[data-section-type="cart"]');

  function updateCartFormItemCount() {
    const cartForm = document.getElementById('cart-recap-form');
    const currentCartSection = document.querySelector('[data-section-type="cart"]');
    if (cartForm && currentCartSection) {
      const itemCount = currentCartSection.getAttribute('data-item-count');
      if (itemCount) {
        cartForm.setAttribute('data-item-count', itemCount);
      }
    }
  }

  function showCartFullPopup() {
    window.themeShowCartFullPopup();
  }

  function hideCartFullPopup() {
    const popup = document.getElementById('cart-full-popup');
    if (popup) {
      popup.setAttribute('aria-hidden', 'true');
    }
  }

  function validateCheckout(event) {
    const checkoutButton = event.submitter;
    // name="checkout"のボタンがクリックされた場合のみチェック
    if (checkoutButton && checkoutButton.name === 'checkout') {
      const cartForm = document.getElementById('cart-recap-form');
      if (!cartForm) {
        return;
      }

      // セクションを再取得（再レンダリング後の可能性があるため）
      const currentCartSection = document.querySelector('[data-section-type="cart"]');

      // セクションまたはフォームから商品数を取得
      const itemCount = parseInt(
        (currentCartSection && currentCartSection.getAttribute('data-item-count')) ||
        cartForm.getAttribute('data-item-count') ||
        '0',
        10
      );

      // カート合計数量が上限（theme.cartMaxLineItems）を超える場合
      if (itemCount > window.themeGetCartMaxLineItems()) {
        event.preventDefault();
        event.stopPropagation();
        showCartFullPopup();
        return false;
      }
    }
  }

  // フォームのsubmitイベントをリッスン
  const cartForm = document.getElementById('cart-recap-form');
  if (cartForm) {
    cartForm.addEventListener('submit', validateCheckout);
  }

  // ポップアップの閉じるボタンのイベントリスナー
  const popup = document.getElementById('cart-full-popup');
  if (popup) {
    const closeButton = popup.querySelector('.custom-cart-full-popup__close');
    if (closeButton) {
      closeButton.addEventListener('click', hideCartFullPopup);
    }

    // オーバーレイをクリックしたときに閉じる
    popup.addEventListener('click', function (event) {
      // ポップアップ本体をクリックした場合は閉じない
      if (event.target === popup) {
        hideCartFullPopup();
      }
    });

    // ポップアップ本体のクリックイベントが伝播しないようにする
    const popupInner = popup.querySelector('.custom-cart-full-popup__inner');
    if (popupInner) {
      popupInner.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    // ESCキーでポップアップを閉じる
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') {
        hideCartFullPopup();
      }
    });
  }

  // カートが再レンダリングされたときにdata-item-countを更新
  document.addEventListener('cart:rerendered', function () {
    updateCartFormItemCount();
    // フォームが再作成された可能性があるので、イベントリスナーを再設定
    const newCartForm = document.getElementById('cart-recap-form');
    if (newCartForm && newCartForm !== cartForm) {
      newCartForm.addEventListener('submit', validateCheckout);
    }
    // ポップアップが再作成された可能性があるので、イベントリスナーを再設定
    const newPopup = document.getElementById('cart-full-popup');
    if (newPopup && newPopup !== popup) {
      const newCloseButton = newPopup.querySelector('.custom-cart-full-popup__close');
      if (newCloseButton) {
        newCloseButton.addEventListener('click', hideCartFullPopup);
      }

      // オーバーレイをクリックしたときに閉じる
      newPopup.addEventListener('click', function (event) {
        if (event.target === newPopup) {
          hideCartFullPopup();
        }
      });

      // ポップアップ本体のクリックイベントが伝播しないようにする
      const newPopupInner = newPopup.querySelector('.custom-cart-full-popup__inner');
      if (newPopupInner) {
        newPopupInner.addEventListener('click', function (event) {
          event.stopPropagation();
        });
      }
    }
  });

  // 初期化時にdata-item-countを更新
  updateCartFormItemCount();

  // カートの総数量を計算する関数
  function getTotalCartQuantity() {
    const quantityInputs = document.querySelectorAll(
      '.custom-quantity-selector__value'
    );
    let totalQuantity = 0;
    quantityInputs.forEach(function (input) {
      const quantity = parseInt(input.value) || 0;
      totalQuantity += quantity;
    });
    return totalQuantity;
  }

  // 数量ボタンのクリックをインターセプトして検証
  function validateQuantityIncrease(event) {
    const button = event.target.closest('[data-action="increase-quantity"]');
    if (!button) {
      return; // increase-quantityボタンでない場合は処理しない
    }

    // 増やそうとしている数量を取得
    const newQuantity = parseInt(button.getAttribute('data-quantity')) || 0;
    const lineIndex = button.getAttribute('data-line');

    // 現在の行の数量を取得
    const currentLineInput = document.querySelector(
      `.custom-quantity-selector__value[data-line="${lineIndex}"]`
    );
    const currentLineQuantity = currentLineInput
      ? parseInt(currentLineInput.value) || 0
      : 0;

    // 商品ごとの数量上限（メタフィールド product_details.quantity_limit）をチェック
    const maxAttr = currentLineInput ? currentLineInput.getAttribute('max') : null;
    const maxQuantity = maxAttr ? parseInt(maxAttr, 10) : null;
    if (maxQuantity !== null && newQuantity > maxQuantity) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      window.themeShowCartFullPopup();
      return false;
    }

    // 増加する数量を計算
    const quantityIncrease = newQuantity - currentLineQuantity;

    // 増加する場合のみチェック
    if (quantityIncrease > 0) {
      // 現在のカートの総数量を取得
      const currentTotalQuantity = getTotalCartQuantity();

      // カートの総数量が上限を超える場合
      var maxCartItemsInCart = window.themeGetCartMaxLineItems();
      if (currentTotalQuantity + quantityIncrease > maxCartItemsInCart) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        window.themeShowCartFullPopup();
        return false;
      }
    }
  }

  // 数量ボタンのクリックイベントをインターセプト（capture phaseで実行）
  document.addEventListener(
    'click',
    validateQuantityIncrease,
    true
  );

  // 数量入力フィールドの変更も検証
  function validateQuantityInput(event) {
    const input = event.target;
    if (
      !input.classList.contains('custom-quantity-selector__value')
    ) {
      return; // 数量入力フィールドでない場合は処理しない
    }

    const newValue = parseInt(input.value) || 0;
    const lineIndex = input.getAttribute('data-line');
    const currentValue = parseInt(input.getAttribute('data-current-value')) || 0;

    // 商品ごとの数量上限（メタフィールド product_details.quantity_limit）をチェック
    const maxAttr = input.getAttribute('max');
    const maxQuantity = maxAttr ? parseInt(maxAttr, 10) : null;
    let effectiveNewValue = newValue;
    if (maxQuantity !== null && newValue > maxQuantity) {
      input.value = maxQuantity;
      input.setAttribute('data-current-value', maxQuantity);
      effectiveNewValue = maxQuantity;
      // 上限に丸めた値でカート更新されるよう、preventDefaultは呼ばない
    }

    // 増加する数量を計算（補正後の値を使用）
    const quantityIncrease = effectiveNewValue - currentValue;

    // 増加する場合のみチェック
    if (quantityIncrease > 0) {
      // 変更前の総数量を計算（現在の入力値を除いて）
      const quantityInputs = document.querySelectorAll(
        '.custom-quantity-selector__value'
      );
      let totalQuantityWithoutCurrent = 0;
      quantityInputs.forEach(function (qtyInput) {
        if (qtyInput !== input) {
          const quantity = parseInt(qtyInput.value) || 0;
          totalQuantityWithoutCurrent += quantity;
        }
      });

      // 変更前の値を加算
      totalQuantityWithoutCurrent += currentValue;

      // 新しい値を加算した総数量を計算（補正後の値を使用）
      const newTotalQuantity = totalQuantityWithoutCurrent - currentValue + effectiveNewValue;

      // カートの総数量が上限を超える場合
      var maxCartItemsInput = window.themeGetCartMaxLineItems();
      if (newTotalQuantity > maxCartItemsInput) {
        event.preventDefault();
        event.stopPropagation();
        // 元の値に戻す
        input.value = currentValue;
        input.setAttribute('data-current-value', currentValue);
        window.themeShowCartFullPopup();
        return false;
      }
    }
  }

  // 数量入力フィールドの変更イベントをリッスン（input と change の二重発火を避ける）
  document.addEventListener('change', validateQuantityInput, true);

  // カート数量入力欄のコミット制御
  // type="number" は上下キー/スピナー操作のたびに change が発火し、ネイティブの数量更新
  // （カートページ=リロード、ドロワー=再レンダリング）が都度走る。上下キーを連続操作すると
  // 複数の更新リクエストが競合し、最初のリクエスト解決時にリロードが走って「一旦古い（少ない）
  // 値で表示 → 後続リクエストで指定値になる」ちらつきが起きる。
  // そこで、編集中（上下キー・タイピング）の中間 change はネイティブ更新へ伝播させず、
  // 入力が止まってから（デバウンス）まとめて1回だけコミットする。Enter 押下時は即時コミットする。
  // コミット済み数量は theme が管理する data-current-value を基準にし、値が変わった場合のみ更新する。
  (function () {
    const commitTimers = new WeakMap(); // input -> デバウンス用タイマー
    const allowCommit = new WeakSet(); // 自前で発火させたコミット用 change を識別
    const COMMIT_DEBOUNCE_MS = 350;

    function isCartQuantityInput(el) {
      if (
        !el ||
        typeof el.closest !== 'function' ||
        !el.classList ||
        !el.classList.contains('quantity-selector__value')
      ) {
        return false;
      }
      const selector = el.closest('.quantity-selector');
      // 商品ページの数量ピッカー（quantity-selector--product）は対象外
      return !!selector && !selector.classList.contains('quantity-selector--product');
    }

    // コミット済み（カートに反映済み）の数量
    function committedValue(input) {
      return input.getAttribute('data-current-value');
    }

    function clearTimer(input) {
      const timer = commitTimers.get(input);
      if (timer) {
        clearTimeout(timer);
        commitTimers.delete(input);
      }
    }

    function commitNow(input) {
      clearTimer(input);
      if (String(input.value) === String(committedValue(input))) {
        return; // コミット済みの数量から変化なし → 余計な更新（リロード）を避ける
      }
      allowCommit.add(input);
      // 自前の change を発火 → ネイティブの数量更新（既存処理）を1回だけ走らせる
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // 編集中の中間 change はネイティブ更新へ伝播させず、入力停止後にまとめてコミットする
    document.addEventListener(
      'change',
      function (event) {
        const input = event.target;
        if (!isCartQuantityInput(input)) {
          return;
        }
        if (allowCommit.has(input)) {
          allowCommit.delete(input); // 自前コミット → ネイティブ更新へ通す
          return;
        }
        // ネイティブの即時更新を止め、デバウンスでまとめる
        event.stopImmediatePropagation();
        clearTimer(input);
        if (String(input.value) === String(committedValue(input))) {
          return; // 変化がなければ何もしない
        }
        commitTimers.set(
          input,
          setTimeout(function () {
            commitNow(input);
          }, COMMIT_DEBOUNCE_MS)
        );
      },
      true
    );

    // Enter 押下時はデバウンスを待たず即時コミットする
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Enter') {
          return;
        }
        const input = event.target;
        if (!isCartQuantityInput(input)) {
          return;
        }
        event.preventDefault();
        commitNow(input);
      },
      true
    );
  })();

  // カートが再レンダリングされたときにイベントリスナーを再設定
  document.addEventListener('cart:rerendered', function () {
    // イベントリスナーは既に設定されているので、特に再設定は不要
    // ただし、数量入力フィールドのdata-current-valueを更新
    const quantityInputs = document.querySelectorAll(
      '.custom-quantity-selector__value'
    );
    quantityInputs.forEach(function (input) {
      input.setAttribute('data-current-value', input.value);
    });
  });
});

/* ===============================================
#Cart Scroll Watcher
=============================================== */
// 2025/12/18 - カートスクロール監視：一番下まで到達したら::beforeを削除（by Watanabe）
document.addEventListener('DOMContentLoaded', function () {
  function initCartScrollWatcher() {
    const cartInner = document.querySelector('.custom-cart-wrapper__inner');
    const cartLayer = document.querySelector('.custom-cart-wrapper__layer');

    if (!cartInner || !cartLayer) {
      return;
    }

    function checkScrollPosition() {
      const scrollTop = cartInner.scrollTop;
      const scrollHeight = cartInner.scrollHeight;
      const clientHeight = cartInner.clientHeight;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1; // 1pxの誤差を許容

      if (isAtBottom) {
        cartLayer.classList.add('custom-cart-wrapper__layer--no-before');
      } else {
        cartLayer.classList.remove('custom-cart-wrapper__layer--no-before');
      }
    }

    // 初期状態をチェック
    checkScrollPosition();

    // スクロールイベントを監視
    cartInner.addEventListener('scroll', checkScrollPosition);

    // リサイズ時もチェック（コンテンツが動的に変更される可能性があるため）
    window.addEventListener('resize', checkScrollPosition);
  }

  // 初期化
  initCartScrollWatcher();

  // カートが再レンダリングされたときにスクロール監視を再設定
  document.addEventListener('cart:rerendered', function () {
    initCartScrollWatcher();
  });
});

/* ===============================================
#Section About Us - Tab Functionality
=============================================== */
/* 2025/12/21 - About Usタブ機能実装（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const sectionElement = document.querySelector('.custom-about__content-inner');
  if (!sectionElement) {
    return;
  }

  const tabButtons = sectionElement.querySelectorAll('.custom-about__tab-button');
  const tabBlocks = sectionElement.querySelectorAll('.custom-about__block');

  // タブ切り替え機能
  tabButtons.forEach(function (tabButton, index) {
    tabButton.addEventListener('click', function () {
      // すべてのタブボタンからactiveクラスを削除
      tabButtons.forEach(function (btn) {
        btn.classList.remove('active');
      });

      // クリックされたタブボタンにactiveクラスを追加
      tabButton.classList.add('active');

      // すべてのブロックからactiveクラスを削除
      tabBlocks.forEach(function (block) {
        block.classList.remove('active');
      });

      // クリックされたタブに対応するブロックを表示
      if (tabBlocks[index]) {
        tabBlocks[index].classList.add('active');
      }
    });
  });
});


// 2025/12/20 - ブログカテゴリープルダウン開閉機能（by Watanabe）
document.addEventListener('click', function (event) {
  const toggleButton = event.target.closest('[data-action="toggle-tag-pulldown"]');
  if (toggleButton) {
    event.preventDefault();
    const pulldown = toggleButton.closest('.custom-page__tag-pulldown');
    const tagList = pulldown.querySelector('.custom-page__tag-list');
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

    toggleButton.setAttribute('aria-expanded', !isExpanded);
    tagList.setAttribute('aria-hidden', isExpanded);
    pulldown.classList.toggle('is-open');
    return;
  }

  // プルダウン外をクリックしたら閉じる
  const pulldown = event.target.closest('.custom-page__tag-pulldown');
  if (!pulldown) {
    const allPulldowns = document.querySelectorAll('.custom-page__tag-pulldown');
    allPulldowns.forEach(function (pd) {
      const btn = pd.querySelector('[data-action="toggle-tag-pulldown"]');
      const list = pd.querySelector('.custom-page__tag-list');
      if (btn && list) {
        btn.setAttribute('aria-expanded', 'false');
        list.setAttribute('aria-hidden', 'true');
        pd.classList.remove('is-open');
      }
    });
  }
});

/* ===============================================
#Custom Template - Text Accordion
=============================================== */
/* 2025/01/02 - Custom Template テキストアコーディオン機能（by Watanabe） */
/* 2026/02/03 - アクセシビリティ改善：スクリーンリーダー対応（抜粋と全文をDOMで分離） */
document.addEventListener('DOMContentLoaded', function () {
  /**
   * テキストを指定された行数に収まるように句点で分割する
   * @param {string} text - 分割するテキスト
   * @param {number} maxLines - 最大行数
   * @param {number} lineHeightPx - 1行の高さ（px）
   * @param {number} fontSize - フォントサイズ（px）
   * @param {HTMLElement} containerElement - 親要素（幅を測定するため）
   * @returns {Object} {excerpt: string, fullText: string, needsTruncation: boolean}
   */
  function splitTextByLines(text, maxLines, lineHeightPx, fontSize, containerElement) {
    // 句点で分割（日本語の句点「。」と英語のピリオド「.」を考慮）
    const sentences = text.split(/([。．.!?！？]\s*)/);
    const reconstructedSentences = [];
    for (let i = 0; i < sentences.length; i += 2) {
      if (sentences[i]) {
        reconstructedSentences.push(
          sentences[i] + (sentences[i + 1] || '')
        );
      }
    }

    // 親要素の幅を取得
    const containerWidth = containerElement.offsetWidth || containerElement.clientWidth || 800;

    // テキストの幅を測定するための一時要素を作成
    const measureEl = document.createElement('span');
    measureEl.style.position = 'absolute';
    measureEl.style.visibility = 'hidden';
    measureEl.style.whiteSpace = 'pre-wrap';
    measureEl.style.wordWrap = 'break-word';
    measureEl.style.fontSize = fontSize + 'px';
    measureEl.style.lineHeight = lineHeightPx + 'px';
    measureEl.style.width = containerWidth + 'px';
    measureEl.style.fontFamily = window.getComputedStyle(containerElement).fontFamily;
    document.body.appendChild(measureEl);

    let excerpt = '';
    const maxHeight = lineHeightPx * maxLines;

    for (let i = 0; i < reconstructedSentences.length; i++) {
      const testText = excerpt + reconstructedSentences[i];
      measureEl.textContent = testText;
      const testHeight = measureEl.offsetHeight;

      if (testHeight <= maxHeight) {
        excerpt = testText;
      } else {
        // 最大行数を超える場合は、現在の抜粋で終了
        break;
      }
    }

    document.body.removeChild(measureEl);

    const needsTruncation = excerpt.length < text.length;
    const fullText = text;

    return {
      excerpt: excerpt.trim(),
      fullText: fullText.trim(),
      needsTruncation: needsTruncation
    };
  }

  function initTextAccordion() {
    const contentElement = document.querySelector('.custom-template__content.hide-text-on');
    if (!contentElement) {
      return;
    }

    const paragraphs = contentElement.querySelectorAll('p:not([data-accordion-processed])');

    paragraphs.forEach(function (paragraph) {
      // 処理済みフラグを設定
      paragraph.setAttribute('data-accordion-processed', 'true');

      // imgタグやiframeタグが含まれている場合は処理を除外
      const hasImage = paragraph.querySelector('img');
      const hasIframe = paragraph.querySelector('iframe');
      if (hasImage || hasIframe) {
        return;
      }

      // 高さをチェック（実際の高さを測定）
      const originalHeight = paragraph.scrollHeight;
      const computedStyle = window.getComputedStyle(paragraph);
      const fontSize = parseFloat(computedStyle.fontSize) || 16;
      const lineHeightValue = computedStyle.lineHeight;
      const lineHeightPx =
        lineHeightValue === 'normal'
          ? fontSize * 1.2
          : parseFloat(lineHeightValue) || fontSize * 1.2;
      // スマホ（767px以下）は20行、それ以外は10行
      const isMobile = window.innerWidth <= 767;
      const linesCount = isMobile ? 20 : 10;
      const thresholdHeight = lineHeightPx * linesCount;

      if (originalHeight > thresholdHeight) {
        // 段落のテキストコンテンツを取得
        const originalText = paragraph.textContent;

        // テキストを分割（親要素の幅を渡す）
        const textSplit = splitTextByLines(
          originalText,
          linesCount,
          lineHeightPx,
          fontSize,
          paragraph
        );

        if (!textSplit.needsTruncation) {
          // 分割が不要な場合は処理をスキップ
          return;
        }

        // hide-textクラスを付与
        paragraph.classList.add('hide-text');

        // 元の段落の内容をクリア
        paragraph.textContent = '';

        // 一意のIDを生成
        const uniqueId = 'text-accordion-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        const excerptId = uniqueId + '-excerpt';
        const fullTextId = uniqueId + '-full';

        // 抜粋部分を作成（スクリーンリーダーに読み上げられる）
        const excerptSpan = document.createElement('span');
        excerptSpan.id = excerptId;
        excerptSpan.className = 'custom-template__text-excerpt';
        excerptSpan.setAttribute('aria-hidden', 'false');
        excerptSpan.textContent = textSplit.excerpt;

        // 全文部分を作成（初期状態ではスクリーンリーダーから隠す）
        const fullTextSpan = document.createElement('span');
        fullTextSpan.id = fullTextId;
        fullTextSpan.className = 'custom-template__text-full';
        fullTextSpan.setAttribute('aria-hidden', 'true');
        fullTextSpan.textContent = textSplit.fullText;
        fullTextSpan.style.display = 'none'; // 視覚的にも非表示

        // 段落に要素を追加
        paragraph.appendChild(excerptSpan);
        paragraph.appendChild(fullTextSpan);

        // ボタンエリアを作成
        const toggleBtnArea = document.createElement('div');
        toggleBtnArea.className = 'custom-template__toggle-btn-area';

        // pタグのstyle属性をtoggleBtnArea要素にコピー
        if (paragraph.hasAttribute('style')) {
          toggleBtnArea.setAttribute('style', paragraph.getAttribute('style'));
        }

        // ボタンを作成
        const toggleBtn = document.createElement('button');
        toggleBtn.className = 'custom-template__toggle-btn';
        toggleBtn.setAttribute('type', 'button');
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.setAttribute('aria-controls', excerptId + ' ' + fullTextId);

        const btnText = document.createElement('span');
        btnText.className = 'custom-template__toggle-btn-text';
        btnText.textContent = 'Read Full Text';

        const btnIcon = document.createElement('span');
        btnIcon.className = 'custom-template__toggle-btn-icon';
        const iconInner = document.createElement('span');
        btnIcon.appendChild(iconInner);

        toggleBtn.appendChild(btnText);
        toggleBtn.appendChild(btnIcon);
        toggleBtnArea.appendChild(toggleBtn);

        // ボタンエリアをpタグの後に挿入
        paragraph.insertAdjacentElement('afterend', toggleBtnArea);

        // クリックイベント
        toggleBtn.addEventListener('click', function () {
          const isExpanded = paragraph.classList.toggle('is-expanded');
          toggleBtn.classList.toggle('is-expanded', isExpanded);
          toggleBtn.setAttribute('aria-expanded', isExpanded);

          if (isExpanded) {
            // 全文を表示：抜粋を非表示、全文を表示
            excerptSpan.setAttribute('aria-hidden', 'true');
            excerptSpan.style.display = 'none';
            fullTextSpan.setAttribute('aria-hidden', 'false');
            fullTextSpan.style.display = '';
            btnText.textContent = 'Hide Full Text';
          } else {
            // 抜粋を表示：抜粋を表示、全文を非表示
            excerptSpan.setAttribute('aria-hidden', 'false');
            excerptSpan.style.display = '';
            fullTextSpan.setAttribute('aria-hidden', 'true');
            fullTextSpan.style.display = 'none';
            btnText.textContent = 'Read Full Text';
          }
        });
      }
    });
  }

  // 初期化
  initTextAccordion();

  // 画像の読み込み完了後にも再チェック
  window.addEventListener('load', function () {
    initTextAccordion();
  });
});

/* ===============================================
#Sitemap - Link Menu Accordion
=============================================== */
/* 2026/01/24 - Sitemap リンクメニューアコーディオン機能（スマホのみ） */
document.addEventListener('DOMContentLoaded', function () {
  function initSitemapAccordion() {
    // スマホ（767px以下）のみ処理
    if (window.innerWidth > 767) {
      return;
    }

    const linkMenus = document.querySelectorAll('.custom-sitemap__link-menu:not([data-accordion-processed])');

    linkMenus.forEach(function (linkMenu) {
      // 処理済みフラグを設定
      linkMenu.setAttribute('data-accordion-processed', 'true');

      const menuItems = linkMenu.querySelectorAll('.custom-sitemap__link-menu-item');
      const itemsCount = menuItems.length;

      // 20個を超える場合のみ処理
      if (itemsCount <= 20) {
        return;
      }

      // 最初の20個以外を非表示にするクラスを付与
      menuItems.forEach(function (item, index) {
        if (index >= 10) {
          item.classList.add('custom-sitemap__link-menu-item--hidden');
        }
      });

      // リンクメニューにhide-itemsクラスを付与
      linkMenu.classList.add('custom-sitemap__link-menu--hide-items');

      // ボタンエリアを作成
      const toggleBtnArea = document.createElement('div');
      toggleBtnArea.className = 'custom-sitemap__toggle-btn-area';

      // ボタンを作成
      const toggleBtn = document.createElement('button');
      toggleBtn.className = 'custom-sitemap__toggle-btn';
      toggleBtn.setAttribute('type', 'button');
      toggleBtn.setAttribute('aria-expanded', 'false');

      const btnText = document.createElement('span');
      btnText.className = 'custom-sitemap__toggle-btn-text';
      btnText.textContent = 'Read Full Text';

      const btnIcon = document.createElement('span');
      btnIcon.className = 'custom-sitemap__toggle-btn-icon';
      const iconInner = document.createElement('span');
      btnIcon.appendChild(iconInner);

      toggleBtn.appendChild(btnText);
      toggleBtn.appendChild(btnIcon);
      toggleBtnArea.appendChild(toggleBtn);

      // ボタンエリアをリンクメニューの後に挿入
      linkMenu.insertAdjacentElement('afterend', toggleBtnArea);

      // クリックイベント
      toggleBtn.addEventListener('click', function () {
        const isExpanded = linkMenu.classList.toggle('is-expanded');
        toggleBtn.classList.toggle('is-expanded', isExpanded);
        toggleBtn.setAttribute('aria-expanded', isExpanded);

        if (isExpanded) {
          btnText.textContent = 'Hide Full Text';
        } else {
          btnText.textContent = 'Read Full Text';
        }
      });
    });
  }

  // 初期化
  initSitemapAccordion();

  // リサイズ時に再チェック（スマホのみ）
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // スマホの場合のみ再初期化
      if (window.innerWidth <= 767) {
        // 処理済みフラグをリセット
        const linkMenus = document.querySelectorAll('.custom-sitemap__link-menu[data-accordion-processed]');
        linkMenus.forEach(function (linkMenu) {
          linkMenu.removeAttribute('data-accordion-processed');
          linkMenu.classList.remove('custom-sitemap__link-menu--hide-items', 'is-expanded');
          const hiddenItems = linkMenu.querySelectorAll('.custom-sitemap__link-menu-item--hidden');
          hiddenItems.forEach(function (item) {
            item.classList.remove('custom-sitemap__link-menu-item--hidden');
          });
          // ボタンエリアを削除
          const btnArea = linkMenu.nextElementSibling;
          if (btnArea && btnArea.classList.contains('custom-sitemap__toggle-btn-area')) {
            btnArea.remove();
          }
        });
        initSitemapAccordion();
      }
    }, 250);
  });
});

// ===============================================
// カスタムドロップダウン機能
// ===============================================
document.addEventListener('DOMContentLoaded', function () {
  const customDropdowns = document.querySelectorAll('.custom-dropdown');

  customDropdowns.forEach(function (dropdown) {
    const select = dropdown.querySelector('.custom-dropdown__select');
    const trigger = dropdown.querySelector('.custom-dropdown__trigger');
    const triggerText = dropdown.querySelector('.custom-dropdown__trigger-text');
    const options = dropdown.querySelectorAll('.custom-dropdown__option');

    if (!select || !trigger || !triggerText || options.length === 0) {
      return;
    }

    // トリガーをクリックしたら開閉
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');

      // 他のドロップダウンを閉じる
      customDropdowns.forEach(function (otherDropdown) {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('is-open');
        }
      });

      // 現在のドロップダウンを開閉
      if (isOpen) {
        dropdown.classList.remove('is-open');
      } else {
        dropdown.classList.add('is-open');
      }
    });

    // オプションをクリックしたら選択
    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.stopPropagation();
        const value = option.getAttribute('data-value');

        if (value) {
          // select要素の値を更新
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          // トリガーテキストを更新
          const optionText = option.querySelector('.custom-dropdown__option-text');
          if (optionText) {
            triggerText.textContent = optionText.textContent;
            dropdown.classList.add('has-selection');
          }

          // 選択状態を更新
          options.forEach(function (opt) {
            opt.classList.remove('is-selected');
          });
          option.classList.add('is-selected');

          // ドロップダウンを閉じる
          dropdown.classList.remove('is-open');
        }
      });
    });

    // select要素の変更を監視（外部から変更された場合）
    select.addEventListener('change', function () {
      const selectedValue = select.value;
      const selectedOption = dropdown.querySelector(
        '.custom-dropdown__option[data-value="' + selectedValue + '"]'
      );

      if (selectedOption) {
        const optionText = selectedOption.querySelector('.custom-dropdown__option-text');
        if (optionText) {
          triggerText.textContent = optionText.textContent;
          dropdown.classList.add('has-selection');
        }

        options.forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
        selectedOption.classList.add('is-selected');
      } else if (selectedValue === '') {
        triggerText.textContent = triggerText.getAttribute('data-placeholder') || 'Select a reason...';
        dropdown.classList.remove('has-selection');
        options.forEach(function (opt) {
          opt.classList.remove('is-selected');
        });
      }
    });

    // 初期状態を設定
    const selectedValue = select.value;
    if (selectedValue) {
      const selectedOption = dropdown.querySelector(
        '.custom-dropdown__option[data-value="' + selectedValue + '"]'
      );
      if (selectedOption) {
        const optionText = selectedOption.querySelector('.custom-dropdown__option-text');
        if (optionText) {
          triggerText.textContent = optionText.textContent;
          dropdown.classList.add('has-selection');
        }
        selectedOption.classList.add('is-selected');
      }
    } else {
      // プレースホルダーを保存
      triggerText.setAttribute('data-placeholder', triggerText.textContent);
    }
  });
});
/* ===============================================
#FAQ Accordion Animation
=============================================== */
/* 2025/12/27 - FAQアコーディオンアニメーション実装（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  // Helpページ: title属性はプレーンテキストのみ（HTML解釈を避ける）
  const tooltipStripElements = document.querySelectorAll('.custom-faq__content-block-text.js-tooltip-strip-html');
  tooltipStripElements.forEach(function (el) {
    el.title = (el.textContent || '').trim();
  });

  // 既存のFAQアコーディオン（サイドバー）
  const detailsElements = document.querySelectorAll('.custom-faq__details.js-details');

  detailsElements.forEach(function (details) {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.custom-faq__details-content');
    const icon = details.querySelector('.custom-faq__group-link-icon');

    if (!summary || !content) {
      return;
    }

    // 初期状態を設定（summaryにaria-expandedは付与しない。WCAG 1.3.1で無効な属性のため）
    if (details.hasAttribute('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      if (icon) {
        icon.style.transform = 'rotate(180deg)';
      }
    } else {
      content.style.maxHeight = '0';
      if (icon) {
        icon.style.transform = 'rotate(0deg)';
      }
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      const isOpen = details.hasAttribute('open');

      if (isOpen) {
        // 閉じるアニメーション
        // 現在の高さを取得（open属性がある状態で）
        const currentHeight = content.scrollHeight;
        // maxHeightに現在の高さを設定
        content.style.maxHeight = currentHeight + 'px';
        // リフローを強制してからアニメーション開始
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            // アニメーション開始（open属性はこの時点ではまだ保持）
            content.style.maxHeight = '0';
            // アイコンの回転も同時に開始
            if (icon) {
              icon.style.transform = 'rotate(0deg)';
            }
          });
        });
        // アニメーション完了後にopen属性を削除
        setTimeout(function () {
          details.removeAttribute('open');
          content.style.maxHeight = '0';
        }, 250);
      } else {
        // 開くアニメーション
        details.setAttribute('open', '');
        content.style.maxHeight = '0';
        // リフローを強制してからアニメーション開始
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            content.style.maxHeight = content.scrollHeight + 'px';
            // アイコンの回転も同時に開始
            if (icon) {
              icon.style.transform = 'rotate(180deg)';
            }
          });
        });
        // アニメーション完了後に最終状態を設定
        setTimeout(function () {
          content.style.maxHeight = content.scrollHeight + 'px';
        }, 250);
      }
    });

    // リサイズ時に高さを再計算
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (details.hasAttribute('open')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      }, 100);
    });
  });

  // コンテンツブロックのFAQアコーディオン
  const contentBlockDetailsElements = document.querySelectorAll('.custom-faq__content-block-details');

  contentBlockDetailsElements.forEach(function (details) {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.custom-faq__content-block-answer');

    if (!summary || !content) {
      return;
    }

    // 初期状態を設定（summaryにaria-expandedは付与しない。WCAG 1.3.1で無効な属性のため）
    if (details.hasAttribute('open')) {
      content.style.maxHeight = content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '0';
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();

      const isOpen = details.hasAttribute('open');

      if (isOpen) {
        // 閉じるアニメーション
        // 現在の高さを取得
        const currentHeight = content.scrollHeight;
        // maxHeightに現在の高さを設定
        content.style.maxHeight = currentHeight + 'px';
        // リフローを強制してからアニメーション開始
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            // アニメーション開始（open属性はこの時点ではまだ保持）
            // max-heightのみをアニメーション
            content.style.maxHeight = '0';
          });
        });
        // アニメーション完了後にopen属性を削除
        setTimeout(function () {
          details.removeAttribute('open');
          content.style.maxHeight = '0';
        }, 300);
      } else {
        // 開くアニメーション
        details.setAttribute('open', '');
        content.style.maxHeight = '0';
        // リフローを強制してからアニメーション開始
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            // max-heightのみをアニメーション
            content.style.maxHeight = content.scrollHeight + 'px';
          });
        });
        // アニメーション完了後に最終状態を設定
        setTimeout(function () {
          content.style.maxHeight = content.scrollHeight + 'px';
        }, 300);
      }
    });

    // リサイズ時に高さを再計算
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (details.hasAttribute('open')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      }, 100);
    });
  });
});

/* ===============================================
#FAQ Anchor Link Focus
=============================================== */
/* アンカーリンククリック時にfocusクラスを付与（by AI） */
document.addEventListener('DOMContentLoaded', function () {
  const anchorLinks = document.querySelectorAll('.custom-faq__details-item');

  anchorLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      // すべてのアンカーリンクからfocusクラスを削除
      anchorLinks.forEach(function (item) {
        item.classList.remove('focus');
      });

      // クリックした要素にfocusクラスを付与
      this.classList.add('focus');
    });
  });
});

/* ===============================================
#Anchor Link Scroll Offset
=============================================== */
/* 2025/12/27 - アンカーリンクでヘッダーの高さを考慮（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  // ヘッダーの高さを取得する関数
  function getHeaderHeight() {
    // CSS変数から取得を試みる
    const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    if (headerHeightVar) {
      const height = parseFloat(headerHeightVar);
      if (!isNaN(height) && height > 0) {
        return height;
      }
    }

    // ヘッダーセクション要素から取得
    const headerSection = document.querySelector('[data-section-type="header"]');
    if (headerSection) {
      return headerSection.offsetHeight;
    }

    // ヘッダー要素から取得
    const header = document.querySelector('.header');
    if (header) {
      return header.offsetHeight;
    }

    // デフォルト値（フォールバック）
    return 0;
  }

  // アンカーリンクのクリックイベントを処理
  document.addEventListener('click', function (event) {
    const anchorLink = event.target.closest('a[href^="#"]');
    if (!anchorLink) {
      return;
    }

    const href = anchorLink.getAttribute('href');
    // 空のアンカー（#のみ）やJavaScriptアンカーは除外
    if (!href || href === '#' || href.startsWith('#javascript:')) {
      return;
    }

    // 対象要素を取得
    const targetId = href.substring(1);
    const targetElement = document.getElementById(targetId);

    if (!targetElement) {
      return;
    }

    // デフォルトの動作を防ぐ
    event.preventDefault();

    // ヘッダーの高さを取得
    const headerHeight = getHeaderHeight();

    // スクロール位置を計算（ヘッダーの高さ分だけオフセット）
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    // スムーズスクロール
    window.scrollTo({
      top: Math.max(0, targetPosition), // 負の値にならないように
      behavior: 'smooth'
    });

    // ハッシュを更新（ブラウザの履歴に追加）
    if (history.pushState) {
      history.pushState(null, null, href);
    } else {
      window.location.hash = href;
    }
  });

  // ページ読み込み時にハッシュがある場合も処理
  function handleInitialHash() {
    if (window.location.hash) {
      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // 少し遅延を入れて、ページが完全に読み込まれた後にスクロール
        setTimeout(function () {
          const headerHeight = getHeaderHeight();
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

          window.scrollTo({
            top: Math.max(0, targetPosition),
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  }

  // 初期ハッシュを処理
  handleInitialHash();

  // ページ読み込み完了後にも処理（動的に追加されるコンテンツに対応）
  window.addEventListener('load', handleInitialHash);
});

/* ===============================================
#Mini Cart Close Functionality
=============================================== */
/* 2025/12/26 - ミニカートのオーバーレイと閉じるボタンでカートを閉じる機能（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  function closeMiniCart() {
    const miniCartElement = document.getElementById('mini-cart');
    const miniCartToggleElement = document.querySelector('[aria-controls="mini-cart"]');

    if (!miniCartElement || !miniCartToggleElement) {
      return;
    }

    // カートが開いている場合のみ閉じる処理を実行
    if (miniCartElement.getAttribute('aria-hidden') === 'false') {
      // カートトグルボタンをクリックしてCartクラスの_toggleMiniCart()を呼び出す
      // これにより、CartインスタンスのisMiniCartOpenフラグも正しく更新される
      miniCartToggleElement.click();
    }
  }

  // オーバーレイのクリックイベント
  document.addEventListener('click', function (event) {
    const overlay = event.target.closest('.custom-mini-cart__overlay');
    if (overlay) {
      closeMiniCart();
    }
  });

  // 閉じるボタンのクリックイベント
  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest('.custom-mini-cart__close-button');
    if (closeButton) {
      event.preventDefault();
      closeMiniCart();
    }
  });

  // 続けて買い物をするリンクのクリックイベント
  document.addEventListener('click', function (event) {
    const continueShoppingLink = event.target.closest('.custom-mini-cart__continue-shopping-link');
    if (continueShoppingLink) {
      event.preventDefault();
      event.stopPropagation();
      closeMiniCart();
    }
  });
});

/* ===============================================
#Login Form Password Toggle
=============================================== */
// パスワード表示/非表示の切り替え
document.addEventListener('DOMContentLoaded', function () {
  const togglePasswordButton = document.querySelector('.custom-form__field-toggle-password');
  const passwordInput = document.getElementById('customer[password]');

  if (togglePasswordButton && passwordInput) {
    // アイコンのSVG定義
    const eyeIcon = '<svg class="icon" width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.71979 9.23083C9.6641 9.23083 10.4661 8.90035 11.1258 8.23938C11.7856 7.5784 12.1154 6.77576 12.1154 5.83146C12.1154 4.88715 11.7849 4.08514 11.124 3.42542C10.463 2.76569 9.66035 2.43583 8.71604 2.43583C7.77174 2.43583 6.96972 2.76632 6.31 3.42729C5.65028 4.08826 5.32042 4.8909 5.32042 5.83521C5.32042 6.77951 5.6509 7.58153 6.31188 8.24125C6.97285 8.90097 7.77549 9.23083 8.71979 9.23083ZM8.71792 8.08333C8.09292 8.08333 7.56167 7.86458 7.12417 7.42708C6.68667 6.98958 6.46792 6.45833 6.46792 5.83333C6.46792 5.20833 6.68667 4.67708 7.12417 4.23958C7.56167 3.80208 8.09292 3.58333 8.71792 3.58333C9.34292 3.58333 9.87417 3.80208 10.3117 4.23958C10.7492 4.67708 10.9679 5.20833 10.9679 5.83333C10.9679 6.45833 10.7492 6.98958 10.3117 7.42708C9.87417 7.86458 9.34292 8.08333 8.71792 8.08333ZM8.71896 11.6667C6.80271 11.6667 5.05667 11.1381 3.48083 10.0808C1.905 9.02375 0.744722 7.60792 0 5.83333C0.744722 4.05875 1.90458 2.64292 3.47958 1.58583C5.05472 0.528611 6.80049 0 8.71688 0C10.6331 0 12.3792 0.528611 13.955 1.58583C15.5308 2.64292 16.6911 4.05875 17.4358 5.83333C16.6911 7.60792 15.5313 9.02375 13.9563 10.0808C12.3811 11.1381 10.6353 11.6667 8.71896 11.6667ZM8.71792 10.4167C10.2874 10.4167 11.7283 10.0035 13.0408 9.17708C14.3533 8.35069 15.3568 7.23611 16.0513 5.83333C15.3568 4.43056 14.3533 3.31597 13.0408 2.48958C11.7283 1.66319 10.2874 1.25 8.71792 1.25C7.14847 1.25 5.7075 1.66319 4.395 2.48958C3.0825 3.31597 2.07903 4.43056 1.38458 5.83333C2.07903 7.23611 3.0825 8.35069 4.395 9.17708C5.7075 10.0035 7.14847 10.4167 8.71792 10.4167Z" fill="currentColor"/></svg>';
    const eyeOffIcon = '<svg class="icon" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.8621 8.15687L10.9263 7.22104C11.0513 6.5309 10.8544 5.91042 10.3356 5.35958C9.81702 4.80889 9.18056 4.59604 8.42625 4.72104L7.49042 3.78521C7.67847 3.70076 7.87132 3.63743 8.06896 3.59521C8.2666 3.55299 8.48292 3.53187 8.71792 3.53187C9.66347 3.53187 10.4661 3.86174 11.1258 4.52146C11.7856 5.18118 12.1154 5.98382 12.1154 6.92937C12.1154 7.16437 12.0943 7.3834 12.0521 7.58646C12.0099 7.78938 11.9465 7.97951 11.8621 8.15687ZM14.5127 10.7498L13.5929 9.88771C14.1207 9.48493 14.5894 9.04396 14.9992 8.56479C15.4089 8.08562 15.7596 7.54049 16.0513 6.92937C15.3568 5.5266 14.3603 4.41201 13.0617 3.58562C11.7631 2.75924 10.3151 2.34604 8.71792 2.34604C8.31514 2.34604 7.91931 2.37382 7.53042 2.42937C7.14153 2.48493 6.75958 2.56826 6.38458 2.67937L5.41354 1.70833C5.94021 1.49889 6.47813 1.34451 7.02729 1.24521C7.57646 1.14576 8.14 1.09604 8.71792 1.09604C10.6708 1.09604 12.432 1.63451 14.0015 2.71146C15.5709 3.7884 16.7157 5.19437 17.4358 6.92937C17.1271 7.67396 16.7283 8.36896 16.2396 9.01437C15.7507 9.65965 15.1751 10.2381 14.5127 10.7498ZM15.1858 15.5704L11.8142 12.2242C11.3868 12.3824 10.9132 12.5117 10.3933 12.6121C9.87361 12.7125 9.31514 12.7627 8.71792 12.7627C6.75958 12.7627 4.9984 12.2242 3.43438 11.1473C1.87021 10.0703 0.725417 8.66437 0 6.92937C0.307639 6.19326 0.705069 5.5066 1.19229 4.86937C1.67951 4.23201 2.21583 3.67937 2.80125 3.21146L0.493542 0.878124L1.37188 0L16.064 14.6921L15.1858 15.5704ZM3.67958 4.08958C3.23931 4.44 2.81111 4.86125 2.395 5.35333C1.97889 5.84528 1.64208 6.37062 1.38458 6.92937C2.07903 8.33215 3.07556 9.44674 4.37417 10.2731C5.67278 11.0995 7.1207 11.5127 8.71792 11.5127C9.09722 11.5127 9.47493 11.4806 9.85104 11.4165C10.227 11.3524 10.5459 11.2862 10.8077 11.2179L9.75313 10.1377C9.61104 10.1953 9.44653 10.2412 9.25958 10.2754C9.07264 10.3097 8.89208 10.3269 8.71792 10.3269C7.77236 10.3269 6.96972 9.99701 6.31 9.33729C5.65028 8.67757 5.32042 7.87493 5.32042 6.92937C5.32042 6.76062 5.33757 6.5841 5.37188 6.39979C5.40604 6.21549 5.45194 6.04694 5.50958 5.89417L3.67958 4.08958Z" fill="currentColor"/></svg>';

    togglePasswordButton.addEventListener('click', function () {
      if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        togglePasswordButton.setAttribute('aria-label', 'パスワードを非表示');
        togglePasswordButton.innerHTML = eyeOffIcon;
      } else {
        passwordInput.type = 'password';
        togglePasswordButton.setAttribute('aria-label', 'パスワードを表示');
        togglePasswordButton.innerHTML = eyeIcon;
      }
    });
  }
});

/* ===============================================
#Collection Page - Fixed Header on Scroll
=============================================== */
/* 2026/01/12 - 商品一覧ページでスクロール時に固定ヘッダーを制御（by Watanabe） */
// document.addEventListener('DOMContentLoaded', function () {
//   const fixedElement = document.querySelector('.custom-card__sp-fixed');
//   if (!fixedElement) {
//     return;
//   }

//   // custom-back-pageの高さを取得する関数
//   function getBackPageHeight() {
//     const backPageElement = document.querySelector('.custom-back-page');
//     if (backPageElement) {
//       return backPageElement.offsetHeight;
//     }

//     // デフォルト値（フォールバック）
//     return 0;
//   }

//   let ticking = false;
//   let isCurrentlyFixed = false;

//   function handleScroll() {
//     if (ticking) {
//       return;
//     }

//     ticking = true;
//     requestAnimationFrame(function () {
//       const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//       const backPageHeight = getBackPageHeight();

//       // custom-back-pageの高さ分スクロールしたら固定
//       const shouldBeFixed = scrollTop >= backPageHeight;

//       // 状態が変わった場合のみクラスを更新（頻繁な切り替えを防ぐ）
//       if (shouldBeFixed !== isCurrentlyFixed) {
//         if (shouldBeFixed) {
//           fixedElement.classList.add('is-fixed');
//           isCurrentlyFixed = true;
//         } else {
//           fixedElement.classList.remove('is-fixed');
//           isCurrentlyFixed = false;
//         }
//       }

//       ticking = false;
//     });
//   }

//   // スクロールイベントリスナーを追加
//   window.addEventListener('scroll', handleScroll, { passive: true });

//   // 初期状態をチェック
//   handleScroll();
// });

/* ===============================================
#Search Bar Input Focus - Prevent is-locked
=============================================== */
/* 2026/01/12 - 検索バーの入力フィールドがフォーカスされたときにis-lockedクラスを削除（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('.search-bar__input.custom-search-bar__input');
  if (!searchInput) {
    return;
  }

  // フォーカス時にis-lockedクラスを削除
  searchInput.addEventListener('focus', function () {
    // theme.jsの_onInputFocus()が実行された後にis-lockedを削除
    // 少し遅延を入れて、theme.jsの処理の後に実行されるようにする
    setTimeout(function () {
      document.documentElement.classList.remove('is-locked');
    }, 0);
  });

  // フォーカスアウト時も念のためis-lockedを削除（theme.jsの処理と競合しないように）
  searchInput.addEventListener('blur', function () {
    setTimeout(function () {
      document.documentElement.classList.remove('is-locked');
    }, 0);
  });
});

/* ===============================================
#Section Slide - Predictive Search（入力で検索結果を表示）
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('.custom-section-slide .custom-section-slide__search-form');
  if (!form) return;

  const input = form.querySelector('[name="q"]');
  const searchResults = form.querySelector('.search-bar__results');
  const resultsInner = form.querySelector('.search-bar__results-inner');
  const menuWrapper = form.querySelector('.search-bar__menu-wrapper');

  if (!input || !searchResults || !resultsInner) return;

  function supportsPredictiveApi() {
    try {
      var el = document.getElementById('shopify-features');
      return el && JSON.parse(el.innerHTML).predictiveSearch;
    } catch (e) {
      return false;
    }
  }

  function closePanel() {
    form.classList.remove('is-expanded', 'is-loading');
    if (searchResults) searchResults.setAttribute('aria-hidden', 'true');
    if (menuWrapper) menuWrapper.setAttribute('aria-hidden', 'true');
    input.classList.remove('is-filled');
  }

  function onInputFocus() {
    form.classList.add('is-expanded');
    var value = (input.value || '').trim();
    if (value === '') {
      if (menuWrapper) menuWrapper.setAttribute('aria-hidden', 'false');
      searchResults.setAttribute('aria-hidden', 'true');
    } else {
      if (menuWrapper) menuWrapper.setAttribute('aria-hidden', 'true');
      searchResults.setAttribute('aria-hidden', 'false');
      input.classList.add('is-filled');
    }
  }

  function doSearch() {
    var currentValue = (input.value || '').trim();
    if (currentValue === '') {
      if (menuWrapper) menuWrapper.setAttribute('aria-hidden', 'false');
      searchResults.setAttribute('aria-hidden', 'true');
      input.classList.remove('is-filled');
      return;
    }
    if (menuWrapper) menuWrapper.setAttribute('aria-hidden', 'true');
    searchResults.setAttribute('aria-hidden', 'false');
    input.classList.add('is-filled');
    form.classList.add('is-loading');

    var url = buildPredictiveSearchSectionUrl(currentValue, supportsPredictiveApi());

    fetch(url, { method: 'GET', credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if ((input.value || '').trim() !== currentValue) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var searchAjax = doc.querySelector('.search-ajax');
        if (!searchAjax) return;

        resultsInner.replaceChildren();
        var viewAll = searchAjax.querySelector('.search-bar__view-all');
        Array.prototype.forEach.call(searchAjax.childNodes, function (node) {
          if (node === viewAll) return;
          resultsInner.appendChild(document.importNode(node, true));
        });
        if (viewAll) {
          resultsInner.appendChild(document.importNode(viewAll, true));
        }
      })
      .catch(function () { })
      .then(function () {
        form.classList.remove('is-loading');
      });
  }

  function debounce(fn, delay) {
    var timer = null;
    return function () {
      clearTimeout(timer);
      var self = this, args = arguments;
      timer = setTimeout(function () { fn.apply(self, args); }, delay);
    };
  }

  input.addEventListener('focus', onInputFocus);
  input.addEventListener('input', debounce(doSearch, 250));

  document.addEventListener('click', function (e) {
    if (form.contains(e.target)) return;
    closePanel();
  });
});

/* ===============================================
#Cart Note Label Icon Fukidashi Toggle
=============================================== */
/* 2026/01/13 - カートページのメモラベルアイコンの吹き出し表示/非表示機能（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const noteLabelIcon = document.querySelector('.custom-cart-recap__note-label-icon');
  const fukidashi = document.querySelector('.custom-cart-recap__note-label-icon-fukidashi');
  const closeButton = document.querySelector('.custom-cart-recap__note-label-icon-fukidashi-close');

  if (!noteLabelIcon || !fukidashi) {
    return;
  }

  // 吹き出しを開く関数
  function openFukidashi() {
    fukidashi.classList.add('is-open');
    noteLabelIcon.classList.add('is-open');
  }

  // 吹き出しを閉じる関数
  function closeFukidashi() {
    fukidashi.classList.remove('is-open');
    noteLabelIcon.classList.remove('is-open');
  }

  // アイコンボタンのクリックイベント
  noteLabelIcon.addEventListener('click', function (e) {
    e.stopPropagation();
    if (fukidashi.classList.contains('is-open')) {
      closeFukidashi();
    } else {
      openFukidashi();
    }
  });

  // 閉じるボタンのクリックイベント
  if (closeButton) {
    closeButton.addEventListener('click', function (e) {
      e.stopPropagation();
      closeFukidashi();
    });
  }

  // 吹き出し内のクリックイベントを止める（documentまで伝播させない）
  fukidashi.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  // 吹き出しの範囲外をクリックしたら閉じる
  document.addEventListener('click', function (e) {
    // 吹き出しが開いている場合のみ処理
    if (!fukidashi.classList.contains('is-open')) {
      return;
    }

    // クリックされた要素が吹き出し内またはアイコンボタン内の場合は閉じない
    const clickedInsideFukidashi = fukidashi.contains(e.target);
    const clickedOnIcon = noteLabelIcon.contains(e.target);

    if (!clickedInsideFukidashi && !clickedOnIcon) {
      closeFukidashi();
    }
  });
});

/* ===============================================
# Order note collapsible – focusable only when visible (AI124, AI125, AI245)
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  const orderNote = document.getElementById('order-note');
  if (!orderNote) return;

  function getFocusables() {
    return orderNote.querySelectorAll(
      '.custom-cart-recap__note-label-icon, .custom-cart-recap__note-label-icon-fukidashi-close, textarea[name="note"]'
    );
  }

  function syncOrderNoteFocusable() {
    const hidden = orderNote.getAttribute('aria-hidden') === 'true';
    getFocusables().forEach(function (el) {
      if (hidden) {
        el.setAttribute('tabindex', '-1');
      } else {
        el.removeAttribute('tabindex');
      }
    });
  }

  syncOrderNoteFocusable();

  const obs = new MutationObserver(function () {
    syncOrderNoteFocusable();
  });
  obs.observe(orderNote, { attributes: true, attributeFilter: ['aria-hidden'] });
});

/* ===============================================
# Cart Note Textarea Resize
=============================================== */
(function () {
  var CART_NOTE_RESIZE_KEY = '_cartNoteResizeInit';

  function initCartNoteResize() {
    var wrapper = document.querySelector('.custom-cart-recap__note-textarea-wrapper');
    if (!wrapper) return;

    if (wrapper[CART_NOTE_RESIZE_KEY]) return;
    wrapper[CART_NOTE_RESIZE_KEY] = true;

    var textarea = wrapper.querySelector('textarea[name="note"]');
    if (!textarea) return;

    var MIN_HEIGHT = 87;
    var RESIZE_STEP = 40;
    var RESIZE_STRIP_PX = 8; // .custom-cart-recap__note-textarea-wrapper::after に合わせる

    function clientYInResizeStrip(targetEl, clientY) {
      var rect = targetEl.getBoundingClientRect();
      return clientY >= rect.bottom - RESIZE_STRIP_PX && clientY <= rect.bottom;
    }

    function resizeTextarea(delta) {
      var currentHeight = textarea.style.height ? parseInt(textarea.style.height, 10) : textarea.offsetHeight;
      var newHeight = Math.max(MIN_HEIGHT, currentHeight + delta);
      textarea.style.height = newHeight + 'px';
    }

    function setTextareaHeight(height) {
      var newHeight = Math.max(MIN_HEIGHT, height);
      textarea.style.height = newHeight + 'px';
    }

    textarea.addEventListener('keydown', function (event) {
      if (!event.altKey) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        resizeTextarea(RESIZE_STEP);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        resizeTextarea(-RESIZE_STEP);
      }
    });

    var isDragging = false;
    var activePointerId = null;
    var startY = 0;
    var startHeight = 0;

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      activePointerId = null;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    }

    function applyPointerMove(e) {
      if (!isDragging || e.pointerId !== activePointerId) return;
      var deltaY = e.clientY - startY;
      var newHeight = startHeight + deltaY;
      setTextareaHeight(newHeight);
    }

    wrapper.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (!clientYInResizeStrip(wrapper, e.clientY)) return;

        e.preventDefault();
        isDragging = true;
        activePointerId = e.pointerId;
        startY = e.clientY;
        startHeight = textarea.style.height ? parseInt(textarea.style.height, 10) : textarea.offsetHeight;

        document.body.style.cursor = 'ns-resize';
        document.body.style.userSelect = 'none';
        try {
          wrapper.setPointerCapture(e.pointerId);
        } catch (err) {
          /* noop */
        }
      },
      true
    );

    wrapper.addEventListener('pointermove', function (e) {
      applyPointerMove(e);
    });

    function finishPointerDrag(e) {
      if (!isDragging || e.pointerId !== activePointerId) return;
      try {
        wrapper.releasePointerCapture(e.pointerId);
      } catch (err2) {
        /* noop */
      }
      endDrag();
    }

    wrapper.addEventListener('pointerup', finishPointerDrag);
    wrapper.addEventListener('pointercancel', finishPointerDrag);
    wrapper.addEventListener('lostpointercapture', endDrag);
  }

  function reinitCartNoteResize() {
    var wrapper = document.querySelector('.custom-cart-recap__note-textarea-wrapper');
    if (wrapper) wrapper[CART_NOTE_RESIZE_KEY] = false;
    initCartNoteResize();
  }

  document.addEventListener('DOMContentLoaded', initCartNoteResize);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) reinitCartNoteResize();
  });

  document.addEventListener('cart:rerendered', reinitCartNoteResize);
})();

/* ===============================================
#Contact Form Textarea Resize
=============================================== */
/* 2026/01/16 - 問い合わせフォームのtextareaのサイズを変更（by Watanabe） */
document.addEventListener('DOMContentLoaded', function () {
  const textareaWrappers = document.querySelectorAll('.custom-contact__textarea-wrapper');
  if (textareaWrappers.length === 0) return;

  const MIN_HEIGHT = 80;
  const RESIZE_STEP = 40;

  textareaWrappers.forEach(function (wrapper) {
    const textarea = wrapper.querySelector('[data-textarea]');
    if (!textarea) return;

    const resizeHandle = wrapper.querySelector('[data-resize-handle]');

    const resizeTextarea = function (delta) {
      const currentHeight = wrapper.style.height ? parseInt(wrapper.style.height) : wrapper.offsetHeight;
      const newHeight = Math.max(MIN_HEIGHT, currentHeight + delta);
      wrapper.style.height = newHeight + 'px';
    };

    const setTextareaHeight = function (height) {
      const newHeight = Math.max(MIN_HEIGHT, height);
      wrapper.style.height = newHeight + 'px';
    };

    // キーボードショートカットでのリサイズ
    textarea.addEventListener('keydown', function (event) {
      if (event.altKey) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          resizeTextarea(RESIZE_STEP);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          resizeTextarea(-RESIZE_STEP);
        }
      }
    });

    // ドラッグでのリサイズ
    if (resizeHandle) {
      let isDragging = false;
      let startY = 0;
      let startHeight = 0;

      resizeHandle.addEventListener('mousedown', function (e) {
        isDragging = true;
        startY = e.clientY;
        startHeight = wrapper.style.height ? parseInt(wrapper.style.height) : wrapper.offsetHeight;
        e.preventDefault();
        document.body.style.cursor = 'ns-resize';
        document.body.style.userSelect = 'none';
      });

      document.addEventListener('mousemove', function (e) {
        if (!isDragging) return;

        const deltaY = e.clientY - startY;
        const newHeight = startHeight + deltaY;
        setTextareaHeight(newHeight);
      });

      document.addEventListener('mouseup', function () {
        if (isDragging) {
          isDragging = false;
          document.body.style.cursor = '';
          document.body.style.userSelect = '';
        }
      });

      // タッチイベント対応
      resizeHandle.addEventListener('touchstart', function (e) {
        isDragging = true;
        startY = e.touches[0].clientY;
        startHeight = wrapper.style.height ? parseInt(wrapper.style.height) : wrapper.offsetHeight;
        e.preventDefault();
      });

      document.addEventListener('touchmove', function (e) {
        if (!isDragging) return;
        const deltaY = e.touches[0].clientY - startY;
        const newHeight = startHeight + deltaY;
        setTextareaHeight(newHeight);
        e.preventDefault();
      });

      document.addEventListener('touchend', function () {
        if (isDragging) {
          isDragging = false;
        }
      });
    }
  });
});

/* Cart gift wrap (PTW) — .ptw-message-note: same resize as contact textarea */
document.addEventListener('DOMContentLoaded', function () {
  const PTW_MESSAGE_NOTE_MIN = 88;
  const PTW_RESIZE_STEP = 40;
  /* .ptw-message-note::after の height と一致させる（ドラッグ可能帯） */
  const PTW_RESIZE_STRIP_PX = 8;

  function clientYInPtwResizeStrip(wrapper, clientY) {
    var rect = wrapper.getBoundingClientRect();
    return clientY >= rect.bottom - PTW_RESIZE_STRIP_PX && clientY <= rect.bottom;
  }

  function initPtwMessageNoteResize(wrapper) {
    if (wrapper.dataset.ptwMessageNoteResizeInit) return;
    var textarea = wrapper.querySelector('#ptw-text-message');
    if (!textarea) return;
    wrapper.dataset.ptwMessageNoteResizeInit = '1';

    var resizeTextarea = function (delta) {
      var currentHeight = wrapper.style.height ? parseInt(wrapper.style.height, 10) : wrapper.offsetHeight;
      var newHeight = Math.max(PTW_MESSAGE_NOTE_MIN, currentHeight + delta);
      wrapper.style.height = newHeight + 'px';
    };

    var setTextareaHeight = function (height) {
      var newHeight = Math.max(PTW_MESSAGE_NOTE_MIN, height);
      wrapper.style.height = newHeight + 'px';
    };

    textarea.addEventListener('keydown', function (event) {
      if (event.altKey) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          resizeTextarea(PTW_RESIZE_STEP);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          resizeTextarea(-PTW_RESIZE_STEP);
        }
      }
    });

    var isDragging = false;
    var activePointerId = null;
    var startY = 0;
    var startHeight = 0;

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      activePointerId = null;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    }

    function applyPointerMove(e) {
      if (!isDragging || e.pointerId !== activePointerId) return;
      var deltaY = e.clientY - startY;
      var newHeight = startHeight + deltaY;
      setTextareaHeight(newHeight);
    }

    /* Pointer Events + setPointerCapture: document の mouseup を取り逃して
       isDragging が残る問題（2回目以降のドラッグ失敗）を防ぐ */
    wrapper.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (!clientYInPtwResizeStrip(wrapper, e.clientY)) return;
        e.preventDefault();
        isDragging = true;
        activePointerId = e.pointerId;
        startY = e.clientY;
        startHeight = wrapper.style.height ? parseInt(wrapper.style.height, 10) : wrapper.offsetHeight;
        document.body.style.cursor = 'ns-resize';
        document.body.style.userSelect = 'none';
        try {
          wrapper.setPointerCapture(e.pointerId);
        } catch (err) {
          /* noop */
        }
      },
      true
    );

    wrapper.addEventListener('pointermove', function (e) {
      applyPointerMove(e);
    });

    function finishPointerDrag(e) {
      if (!isDragging || e.pointerId !== activePointerId) return;
      try {
        wrapper.releasePointerCapture(e.pointerId);
      } catch (err2) {
        /* noop */
      }
      endDrag();
    }

    wrapper.addEventListener('pointerup', finishPointerDrag);
    wrapper.addEventListener('pointercancel', finishPointerDrag);
    wrapper.addEventListener('lostpointercapture', endDrag);
  }

  function scanPtwMessageNotes(root) {
    root.querySelectorAll('.ptw-message-note').forEach(function (el) {
      initPtwMessageNoteResize(el);
    });
  }

  var giftWrapRoot = document.querySelector('#gift-wrap');
  if (giftWrapRoot) {
    scanPtwMessageNotes(giftWrapRoot);
    var mo = new MutationObserver(function () {
      scanPtwMessageNotes(giftWrapRoot);
    });
    mo.observe(giftWrapRoot, { childList: true, subtree: true });
  }
});

// Back page link functionality
// キャプチャフェーズでdocumentレベルで登録して、確実に先に実行されるようにする
document.addEventListener('click', function (e) {
  const backPageLink = e.target.closest('.custom-back-page__link');
  if (backPageLink) {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (window.history.length > 1) {
      window.history.back();
    } else {
      // 履歴がない場合はホームページに遷移
      window.location.href = '/';
    }
    return false;
  }
}, true); // キャプチャフェーズで登録

/* ===============================================
#Line Clamp
=============================================== */
function clampByLines(element, lines) {
  // 元のテキストを保存（初回のみ）
  if (!element.dataset.originalText) {
    element.dataset.originalText = element.textContent;
    // スクリーンリーダー用にaria-labelにも全文を設定
    element.setAttribute('aria-label', element.textContent);
  }

  const originalText = element.dataset.originalText;

  // 元のテキストを復元してから判定
  element.textContent = originalText;
  // aria-labelも常に全文を保持
  element.setAttribute('aria-label', originalText);

  const style = window.getComputedStyle(element);
  let lineHeight;

  // data-line-height属性で手動指定されている場合はそれを使用
  if (element.dataset.lineHeight) {
    const customLineHeight = parseFloat(element.dataset.lineHeight);
    if (!isNaN(customLineHeight) && customLineHeight > 0) {
      lineHeight = customLineHeight;
    }
  }

  // 手動指定がない場合は、CSSから取得
  if (!lineHeight) {
    lineHeight = parseFloat(style.lineHeight);
  }

  // lineHeightがnormalやNaNの場合は、fontSizeから計算
  if (isNaN(lineHeight) || lineHeight === 0) {
    const fontSize = parseFloat(style.fontSize);
    lineHeight = fontSize * 1.1; // デフォルトのline-heightは通常1.5倍
  }

  // 実際の1行の高さを測定（要素に1行のテキストを設定して測定）
  const testText = 'A';
  element.textContent = testText;
  const singleLineHeight = element.scrollHeight;

  // paddingを考慮してmaxHeightを計算
  const paddingTop = parseFloat(style.paddingTop) || 0;
  const paddingBottom = parseFloat(style.paddingBottom) || 0;

  // 実際の1行の高さ（paddingを除く）
  const actualLineHeight = singleLineHeight - paddingTop - paddingBottom;

  // 実際の行高さを使用してmaxHeightを計算
  const maxHeight = (actualLineHeight * lines) + paddingTop + paddingBottom;

  // 元のテキストを復元
  element.textContent = originalText;

  // 行数以内に収まる場合はそのまま表示
  if (element.scrollHeight <= maxHeight) {
    element.textContent = originalText;
    // aria-labelも全文を保持
    element.setAttribute('aria-label', originalText);
    return;
  }

  let low = 0;
  let high = originalText.length;
  let truncated = originalText;

  // 二分探索で最適な文字数を探す（高速）
  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    element.textContent = originalText.slice(0, mid) + '…"';

    if (element.scrollHeight > maxHeight) {
      high = mid - 1;
    } else {
      truncated = element.textContent;
      low = mid + 1;
    }
  }

  element.textContent = truncated;
  // テキストが切り詰められても、aria-labelには全文を保持（スクリーンリーダー用）
  element.setAttribute('aria-label', originalText);
}

function applyLineClamp() {
  document.querySelectorAll('.js-line-clamp').forEach(el => {
    // ウィンドウ幅に応じて行数を決定
    // 767px以下（スマホ）: 3行、768px以上（PC）: 2行
    const width = window.innerWidth;
    const lines = width >= 768 ? 2 : 3;

    // 元のテキストを確実に復元（常に復元）
    if (el.dataset.originalText) {
      el.textContent = el.dataset.originalText;
      // aria-labelも全文を保持
      el.setAttribute('aria-label', el.dataset.originalText);
    }

    // 行数を適用
    clampByLines(el, lines);
  });
}

// 初期実行（DOMContentLoaded後に実行）
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyLineClamp);
} else {
  applyLineClamp();
}

// リサイズ時にも再実行（デバウンス付き）
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    applyLineClamp();
  }, 100);
});

/* ===============================================
#2026/02/01 - ギフトラップチェックボックスの状態をhiddenフィールドに反映（by Watanabe）
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  const giftWrapCheckbox = document.getElementById('gift-wrap-checkbox');
  const giftWrapHidden = document.getElementById('gift-wrap-hidden');

  if (giftWrapCheckbox && giftWrapHidden) {
    // チェックボックスの状態変更時にhiddenフィールドの値を更新
    giftWrapCheckbox.addEventListener('change', function () {
      giftWrapHidden.value = this.checked ? 'true' : '';
    });

    // フォーム送信時にも確実に値を設定
    const cartForm = document.getElementById('cart-recap-form');
    if (cartForm) {
      cartForm.addEventListener('submit', function () {
        giftWrapHidden.value = giftWrapCheckbox.checked ? 'true' : '';
      });
    }
  }
});

/* ===============================================
# Predictive search – preserve focus order (submit before results)
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  const headerSearchInput = document.querySelector(
    '.header__search-bar-wrapper .search-bar__input.custom-search-bar__input'
  );
  if (!headerSearchInput) return;

  headerSearchInput.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    // theme.js の SearchBar._handleTab() に渡さず、通常のTab順（送信ボタン→結果）を維持する
    event.stopPropagation();
  });
});

/* ===============================================
# カートカウント更新時のaria-label更新
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  // カートリンクのaria-labelを更新する関数
  function updateCartAriaLabel() {
    const cartLink = document.querySelector('.custom-header__cart-toggle, .header__cart-toggle');
    const cartCountElement = document.querySelector('.custom-header__cart-count, .header__cart-count');

    if (!cartLink || !cartCountElement) {
      return;
    }

    // カートカウントを取得（data-actual-count属性から正確な数値を取得、なければtextContentから）
    let itemCount = 0;
    if (cartCountElement.hasAttribute('data-actual-count')) {
      itemCount = parseInt(cartCountElement.getAttribute('data-actual-count')) || 0;
    } else {
      const text = cartCountElement.textContent.trim();
      const parsedCount = parseInt(text);
      if (!isNaN(parsedCount)) {
        itemCount = parsedCount;
      } else if (text === '99+') {
        // 「99+」の場合は、ミニカートやカートセクションから取得を試みる
        const miniCart = document.getElementById('mini-cart');
        if (miniCart && miniCart.getAttribute('data-item-count')) {
          itemCount = parseInt(miniCart.getAttribute('data-item-count')) || 0;
        } else {
          const cartSection = document.querySelector('[data-section-type="cart"]');
          if (cartSection && cartSection.getAttribute('data-item-count')) {
            itemCount = parseInt(cartSection.getAttribute('data-item-count')) || 0;
          }
        }
      }
    }

    // data属性から翻訳テキストを取得（AI129: "button"/"link" は accessible name に含めない）
    const cartLabel = cartLink.getAttribute('data-cart-label') || 'カート';
    const cartEmpty = cartLink.getAttribute('data-cart-empty') || 'カートは空です';
    const itemsCount = cartLink.getAttribute('data-cart-items-count') || '個の商品';

    // aria-labelを更新
    if (itemCount === 0) {
      cartLink.setAttribute('aria-label', cartLabel + ' (' + cartEmpty + ')');
    } else {
      cartLink.setAttribute('aria-label', cartLabel + ' ' + itemCount + ' ' + itemsCount);
    }
  }

  // カートが再レンダリングされたときにaria-labelを更新
  document.addEventListener('cart:rerendered', function () {
    updateCartAriaLabel();
  });

  // カートカウント要素の変更を監視
  const cartCountElement = document.querySelector('.custom-header__cart-count, .header__cart-count');
  if (cartCountElement) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          updateCartAriaLabel();
        }
      });
    });

    observer.observe(cartCountElement, {
      childList: true,
      characterData: true,
      subtree: true
    });

    // 初期化時にaria-labelを更新
    updateCartAriaLabel();
  }

  // カートカウントを「99+」形式に変換する関数
  function formatCartCount(element) {
    if (!element) return;

    const text = element.textContent.trim();
    // 数値として解析を試みる
    const count = parseInt(text);

    // 数値として解析でき、100以上の場合
    if (!isNaN(count) && count >= 100) {
      element.textContent = '99+';
      element.classList.add('custom-header__cart-count--over');
      // 正確な数値をdata属性に保存（aria-label用）
      element.setAttribute('data-actual-count', count);
    }
    // 既に「99+」の場合はクラスを追加（元の数値が100以上だったことが確定）
    else if (text === '99+') {
      element.classList.add('custom-header__cart-count--over');
      // data属性が既に存在する場合はそのまま、存在しない場合は100として扱う
      if (!element.hasAttribute('data-actual-count')) {
        element.setAttribute('data-actual-count', '100');
      }
    }
    // 数値として解析でき、100未満の場合
    else if (!isNaN(count) && count < 100) {
      element.classList.remove('custom-header__cart-count--over');
      // 正確な数値をdata属性に保存
      element.setAttribute('data-actual-count', count);
    }
    // 数値として解析できない場合はクラスを削除（安全のため）
    else {
      element.classList.remove('custom-header__cart-count--over');
      // data属性も削除
      element.removeAttribute('data-actual-count');
    }
  }

  // カートカウント要素を取得してフォーマットする関数
  function formatCartCountElement() {
    const cartCountElement = document.querySelector(
      '.header__cart-count.custom-header__cart-count, .custom-header__cart-count, .header__cart-count'
    );
    if (cartCountElement) {
      formatCartCount(cartCountElement);
    }
  }

  // MutationObserverのインスタンスを保持
  let cartCountObserver = null;

  // カートカウント要素を取得してMutationObserverを設定
  function initCartCountFormatter() {
    const cartCountElement = document.querySelector(
      '.header__cart-count.custom-header__cart-count, .custom-header__cart-count, .header__cart-count'
    );

    if (cartCountElement) {
      // 既存のObserverを切断
      if (cartCountObserver) {
        cartCountObserver.disconnect();
      }

      // 初期値をフォーマット
      formatCartCount(cartCountElement);

      // MutationObserverで変更を監視
      cartCountObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            // 変更後の値を取得
            const newText = cartCountElement.textContent.trim();
            const newCount = parseInt(newText);

            // 数値として解析できる場合、正確な数値をdata属性に保存（formatCartCount実行前）
            if (!isNaN(newCount)) {
              cartCountElement.setAttribute('data-actual-count', newCount);
            }

            // フォーマットを実行
            formatCartCount(cartCountElement);
          }
        });
      });

      cartCountObserver.observe(cartCountElement, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  // カートカウントフォーマッターを初期化
  initCartCountFormatter();

  // カートが再レンダリングされたときにも実行（theme.jsのイベントを監視）
  document.addEventListener('cart:rerendered', function () {
    // 即座にフォーマットを実行
    formatCartCountElement();
    // MutationObserverを再設定（要素が再作成された可能性があるため）
    setTimeout(initCartCountFormatter, 50);
  });
});

/* ===============================================
# Skip to content – move focus to main content
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  const skipLink = document.querySelector('.skip-to-content[href="#main"]');
  const main = document.getElementById('main');

  if (!skipLink || !main) return;

  if (!main.hasAttribute('tabindex')) {
    main.setAttribute('tabindex', '-1');
  }

  skipLink.addEventListener('click', function (event) {
    event.preventDefault();
    main.focus();
  });
});

/* ===============================================
# Mini cart dialog a11y (MI1)
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  const miniCart = document.getElementById('mini-cart');
  const toggle = document.querySelector('.header__cart-toggle[aria-controls="mini-cart"]');
  const main = document.getElementById('main');

  if (!miniCart || !toggle) return;

  let lastFocused = null;

  function isOpenMiniCart() {
    return miniCart.getAttribute('aria-hidden') === 'false';
  }

  function openMiniCartA11y() {
    lastFocused = document.activeElement;
    if (main) {
      main.setAttribute('aria-hidden', 'true');
    }
    if (!miniCart.hasAttribute('tabindex')) {
      miniCart.setAttribute('tabindex', '-1');
    }
    miniCart.focus();
  }

  function closeMiniCartA11y() {
    if (main) {
      main.removeAttribute('aria-hidden');
    }
    const fallback = toggle;
    const target = lastFocused && document.contains(lastFocused) ? lastFocused : fallback;
    if (target) target.focus();
  }

  const miniCartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type !== 'attributes' || mutation.attributeName !== 'aria-hidden') return;
      if (isOpenMiniCart()) {
        openMiniCartA11y();
      } else {
        closeMiniCartA11y();
      }
    });
  });
  miniCartObserver.observe(miniCart, { attributes: true, attributeFilter: ['aria-hidden'] });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!isOpenMiniCart()) return;
    event.preventDefault();
    toggle.click();
  });
});

/**
 * アクセシビリティ対応: .header__cart-icon（div）にaria-expandedが付与されないようにする
 * theme.jsがdivにaria-expandedを付けるため、MutationObserverで除去する（generic roleでは禁止のため）
 */
function removeAriaExpandedFromCartIcon() {
  const cartIcon = document.querySelector('.header__cart-icon');
  if (!cartIcon) return;
  cartIcon.removeAttribute('aria-expanded');
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'aria-expanded') {
        cartIcon.removeAttribute('aria-expanded');
      }
    });
  });
  observer.observe(cartIcon, { attributes: true, attributeFilter: ['aria-expanded'] });
}
document.addEventListener('DOMContentLoaded', removeAriaExpandedFromCartIcon);
document.addEventListener('cart:rerendered', function () {
  setTimeout(removeAriaExpandedFromCartIcon, 100);
});

/* ===============================================
# Splide a11y - hide non-visible controls from AT
=============================================== */
function isVisuallyAvailable(element) {
  if (!element) return false;
  if (!element.isConnected) return false;

  const style = window.getComputedStyle(element);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  if (element.getClientRects().length === 0) return false;

  return true;
}

function updateSplideControlsA11y() {
  const splides = document.querySelectorAll('.splide');
  if (!splides.length) return;

  splides.forEach(function (splide) {
    const arrows = splide.querySelectorAll('.splide__arrow');
    const pages = splide.querySelectorAll('.splide__pagination__page');

    arrows.forEach(function (btn) {
      const available = isVisuallyAvailable(btn) && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true';
      if (!available) {
        btn.setAttribute('aria-hidden', 'true');
        btn.setAttribute('tabindex', '-1');
      } else {
        btn.removeAttribute('aria-hidden');
        btn.removeAttribute('tabindex');
      }
    });

    pages.forEach(function (btn) {
      const available = isVisuallyAvailable(btn) && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true';
      if (!available) {
        btn.setAttribute('aria-hidden', 'true');
        btn.setAttribute('tabindex', '-1');
      } else {
        btn.removeAttribute('aria-hidden');
        btn.removeAttribute('tabindex');
      }
    });
  });
}

function initSplideControlsA11y() {
  let timer = null;

  function schedule() {
    if (timer) return;
    timer = window.setTimeout(function () {
      timer = null;
      updateSplideControlsA11y();
    }, 0);
  }

  // 初期化（Splideが後からDOMを作るケースもあるため、遅延も入れる）
  schedule();
  window.setTimeout(schedule, 50);
  window.setTimeout(schedule, 250);

  window.addEventListener('resize', schedule);

  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!target) return;
    if (target.closest('.splide')) schedule();
  });

  const observer = new MutationObserver(function () {
    schedule();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-hidden', 'aria-disabled', 'disabled']
  });
}

document.addEventListener('DOMContentLoaded', initSplideControlsA11y);

/* ===============================================
# Collection/Search layout buttons – sync aria-pressed (AI633, AI634)
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-action="change-layout"]');
    if (!btn) return;
    const container = btn.closest('.collection__toolbar-item--layout');
    if (!container) return;

    // theme.js 側で is-selected を更新したあとに aria-pressed を同期させる
    setTimeout(function () {
      container.querySelectorAll('.collection__layout-button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.classList.contains('is-selected') ? 'true' : 'false');
      });
    }, 0);
  });
});

/* ===============================================
# 18歳以上確認ポップアップ（by Watanabe）
=============================================== */
(function () {
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  function getFocusableElements(container) {
    var focusableSelectors = [
      'button:not([disabled])',
      '[href]',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ];
    return Array.from(container.querySelectorAll(focusableSelectors.join(', ')));
  }

  function trapFocus(container, event) {
    var focusableElements = getFocusableElements(container);
    if (focusableElements.length === 0) return;

    var firstElement = focusableElements[0];
    var lastElement = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  }

  function initAdultVerificationModal() {
    var modal = document.getElementById('custom-adult-verification-modal');
    if (!modal) return;

    var dialog = modal.querySelector('[role="dialog"]');
    if (!dialog) return;

    if (getCookie('adult_verified') === 'true') {
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');

      var ageConfirmWrap = document.querySelector('.custom-form__age-confirm-tooltip-wrap');
      if (ageConfirmWrap) {
        ageConfirmWrap.style.display = 'none';
      }

      var ageConfirmCheckbox = document.getElementById('AgeConfirm');
      if (ageConfirmCheckbox) {
        ageConfirmCheckbox.checked = true;
      }

      return;
    }

    var trapFocusHandler = null;
    var escapeKeyHandler = null;
    var previousActiveElement = null;
    var titleElement = null;

    function openDialog() {
      previousActiveElement = document.activeElement;

      modal.style.display = 'grid';
      modal.setAttribute('aria-hidden', 'false');

      setTimeout(function () {
        var focusableElements = getFocusableElements(dialog);
        if (focusableElements.length > 0) {
          focusableElements[0].focus();
        } else {
          titleElement = dialog.querySelector('#custom-adult-verification-modal__title');
          if (titleElement) {
            titleElement.setAttribute('tabindex', '-1');
            titleElement.focus();
          }
        }
      }, 0);

      trapFocusHandler = function (event) {
        trapFocus(dialog, event);
      };
      dialog.addEventListener('keydown', trapFocusHandler);
    }

    function closeDialog() {
      setCookie('adult_verified', 'true', 14);

      if (trapFocusHandler) {
        dialog.removeEventListener('keydown', trapFocusHandler);
        trapFocusHandler = null;
      }

      if (escapeKeyHandler) {
        document.removeEventListener('keydown', escapeKeyHandler);
        escapeKeyHandler = null;
      }

      if (titleElement && titleElement.hasAttribute('tabindex')) {
        titleElement.removeAttribute('tabindex');
      }

      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');

      if (previousActiveElement && previousActiveElement !== document.body) {
        if (document.body.contains(previousActiveElement)) {
          previousActiveElement.focus();
        } else {
          document.body.focus();
        }
      } else {
        document.body.focus();
      }
    }

    escapeKeyHandler = function (event) {
      if (event.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        window.history.back();
      }
    };

    var continueBtn = modal.querySelector('[data-action="continue"]');
    var exitBtn = modal.querySelector('[data-action="exit"]');

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        closeDialog();
      });
    }

    if (exitBtn) {
      exitBtn.addEventListener('click', function () {
        window.history.back();
      });
    }

    document.addEventListener('keydown', escapeKeyHandler);

    openDialog();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAdultVerificationModal);
  } else {
    initAdultVerificationModal();
  }
})();

/* ===== Collection / search products count (theme.js JSON 互換・textContent) ===== */
(function () {
  function applyCollectionProductsCount(section) {
    if (!section) return;

    var scriptEl = section.querySelector('[data-collection-products-count]');
    if (!scriptEl) return;

    var data;
    try {
      data = JSON.parse(scriptEl.textContent.trim());
    } catch (error) {
      return;
    }

    var totalEl = section.querySelector('.collection__products-count-total');
    if (totalEl && data.productsCount != null) {
      totalEl.textContent = data.productsCount;
    }

    var showingEl = section.querySelector('.collection__products-count-showing');
    if (showingEl && data.showingCount != null) {
      showingEl.textContent = data.showingCount;
    }
  }

  function syncAllCollectionProductsCounts() {
    document.querySelectorAll('[data-section-type="collection"]').forEach(applyCollectionProductsCount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllCollectionProductsCounts);
  } else {
    syncAllCollectionProductsCounts();
  }

  document.addEventListener('theme:loading:end', syncAllCollectionProductsCounts);
})();

/* ===============================================
# Collection list product-item 寸法 → CSS変数
=============================================== */
(function () {
  var PART_SELECTOR = '.custom-collection__dynamic-part';
  // theme.js の _changeLayout は item.className を完全上書きするため
  // `custom-product-item` を要件にせず、part スコープで安全に拾えるよう緩める
  var LIST_ITEM_SELECTOR = '.product-item.product-item--list';
  var LAYOUT_BUTTON_SELECTOR = '[data-action="change-layout"]';
  var WIDTH_VAR = '--custom-product-item-list-width';
  var HEIGHT_VAR = '--custom-product-item-list-height';
  var boundParts = new WeakSet();
  var resizeObserver = null;
  var mutationObservers = [];

  function setListItemSizeVars(item) {
    item.style.setProperty(WIDTH_VAR, item.offsetWidth + 'px');
    item.style.setProperty(HEIGHT_VAR, item.offsetHeight + 'px');
  }

  function observeListItems(part) {
    if (!window.ResizeObserver) {
      return;
    }
    if (!resizeObserver) {
      resizeObserver = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          setListItemSizeVars(entry.target);
        });
      });
    }
    part.querySelectorAll(LIST_ITEM_SELECTOR).forEach(function (item) {
      resizeObserver.observe(item);
      setListItemSizeVars(item);
    });
  }

  function syncPart(part) {
    part.querySelectorAll(LIST_ITEM_SELECTOR).forEach(setListItemSizeVars);
  }

  // theme.js の _changeLayout は fastdom.mutate() でクラス書き換えを次フレームに
  // 回すので、double rAF を挟んで「書き換え後」のサイズを取得する
  function scheduleResyncAfterLayoutChange(part) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        observeListItems(part);
        syncPart(part);
      });
    });
  }

  function bindPart(part) {
    if (boundParts.has(part)) {
      syncPart(part);
      observeListItems(part);
      return;
    }
    boundParts.add(part);
    syncPart(part);
    observeListItems(part);

    var mutationObserver = new MutationObserver(function () {
      observeListItems(part);
      syncPart(part);
    });
    mutationObserver.observe(part, { childList: true, subtree: true });
    mutationObservers.push(mutationObserver);

    // レイアウト切替ボタン押下時に再計測。
    // part 自体は _reload の innerHTML 差し替えでも残るので、ここに 1 個だけ委譲する
    part.addEventListener('click', function (event) {
      var trigger = event.target && event.target.closest
        ? event.target.closest(LAYOUT_BUTTON_SELECTOR)
        : null;
      if (!trigger || !part.contains(trigger)) {
        return;
      }
      scheduleResyncAfterLayoutChange(part);
    });
  }

  function init() {
    document.querySelectorAll(PART_SELECTOR).forEach(bindPart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('theme:loading:end', init);
  window.addEventListener('resize', init);
})();

/* ===============================================
# Google Preview 対応（by Ito）
=============================================== */
document.addEventListener('DOMContentLoaded', function () {
  const previewBlocks = document.querySelectorAll('.js-google-preview');
  previewBlocks.forEach((block) => {
    const setAttributes = () => {
      const links = block.querySelectorAll('a[href*="books.google.com"]');
      links.forEach((link) => {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
      });
    };

    setAttributes();
    const observer = new MutationObserver(setAttributes);

    observer.observe(block, {
      childList: true,
      subtree: true,
    });
  });
});

/* ===============================================
# Persist cart order note (cart.note / order.note)
# Save on input/blur, and flush before checkout submit
=============================================== */
(function () {
  function getCartForm() {
    return document.getElementById('cart-recap-form');
  }

  function getNoteTextarea(form) {
    return form ? form.querySelector('textarea[name="note"]') : null;
  }

  function persistCartNote(form) {
    const textarea = getNoteTextarea(form);
    if (!textarea || !window.routes || !window.routes.cartUrl) {
      return Promise.resolve();
    }

    return fetch(window.routes.cartUrl + '/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ note: textarea.value }),
    });
  }

  function bindCartNotePersistence() {
    const form = getCartForm();
    if (!form || form.dataset.orderNotePersistBound === 'true') return;
    if (!getNoteTextarea(form)) return;

    form.dataset.orderNotePersistBound = 'true';

    const textarea = getNoteTextarea(form);
    let saveTimer = null;

    const saveSoon = function () {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        persistCartNote(form).catch(function () {});
      }, 400);
    };

    textarea.addEventListener('input', saveSoon);
    textarea.addEventListener('blur', function () {
      clearTimeout(saveTimer);
      persistCartNote(form).catch(function () {});
    });

    form.addEventListener(
      'submit',
      function (event) {
        if (form.dataset.orderNoteReady === 'true') {
          form.dataset.orderNoteReady = 'false';
          return;
        }

        const submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;

        event.preventDefault();
        event.stopPropagation();

        clearTimeout(saveTimer);
        persistCartNote(form)
          .catch(function () {})
          .finally(function () {
            form.dataset.orderNoteReady = 'true';
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit(submitter);
            } else {
              form.submit();
            }
          });
      },
      true
    );
  }

  function initCartNotePersistence() {
    bindCartNotePersistence();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartNotePersistence);
  } else {
    initCartNotePersistence();
  }

  document.addEventListener('cart:rerendered', initCartNotePersistence);
})();
